<template>
  <div>
    <breadcrumb :routerList="[{to:'/loudnew/LoudMain',title:'信息漏斗'},{ title:'编辑'}]" />
    <div class="h-piece" style="margin:20px">
      <div class="h-formBox">
        <!-- 步骤导航 -->
        <el-steps simple :active="activeStep" finish-status="success" v-if="projectForm.isBid==1">
          <el-step v-for="(item, index) in stepsList" :key="item.code" :title="item.name" />
        </el-steps>
        <!-- 表单内容 -->
        <el-form
                ref="projectForm"
                :model="projectForm"
                :rules="formRules"
                label-position="right"
                :inline="true"
                class="demo-ruleForm h-formbLine"
        >
          <div class="content">
            <el-collapse v-model="activePanels">
              <!-- 基本信息 -->
              <el-collapse-item name="X">
                <template slot="title">
                  <span class="collapseTitle" style="color: #000">基本信息</span>
                  <i :class="activePanels.includes('X')?'el-icon-arrow-down':'el-icon-arrow-right'"
                     style="margin-left: 4px;font-size: 14px;font-weight: 600" />
                </template>
                <el-form-item label="需求名称" class="demandName" style="width: 100%">
                  <el-input v-model="projectForm.projectName" placeholder="请输入需求名称" style="width: 100%"/>
                </el-form-item>
                <el-form-item label="需求分类" class="h-elformWrap-2">
                  <el-select v-model="projectForm.probjectSorts" :v="projectForm.probjectSorts"  :clearable="true">
                    <el-option label="货物类" value="sd"></el-option>
                    <el-option label="工程类" value="xm"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="机会分类" class="h-elformWrap-2">
                  <el-select v-model="projectForm.chanceType" :v="projectForm.chanceType" :clearable="true">
                    <el-option v-for="(item) in xiangmu"
                               :key="item.code"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="区域" class="h-elformWrap-2" >
                  <brselect category="show_area" v-model="projectForm.areaCode" :v="projectForm.areaCode" :clearable="true"
                            @change="matchsalesman($event)" />
                </el-form-item>

                <el-form-item label="用户单位" class="h-elformWrap-2" >
                  <el-select v-model="projectForm.customerName" remote filterable :filter-method="showGroupList" :clearable="true"
                             placeholder="请输入" :popper-append-to-body="false" style="width: 90%"
                             :remote-method="showGroupList" @change="showGroupList" >
                    <el-option v-for="(item,index) in customerNameList"
                               :key="index"
                               :label="item.deptName"
                               :value="item.deptName">
                    </el-option>
                  </el-select>
                  <i class="el-icon-circle-plus" @click="createAddress" style="cursor: pointer"/>
                </el-form-item>

                <el-form-item label="销售人员" class="h-elformWrap-2" >
                  <el-select v-model="projectForm.salesman" placeholder="销售人员"  @change="salesmanChange($event)"
                             filterable allow-create default-first-option clearable>
                    <el-option
                            v-for="item in salesmanList"
                            :key="item.id"
                            :label="item.userName"
                            :value="item.userName">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="经销商名称" class="h-elformWrap-2" prop="agentName">
                  <el-select v-model="projectForm.agentName" remote filterable :filter-method="showComList" clearable
                             placeholder="请输入"
                             :remote-method="showComList" @change="showComList">
                    <el-option v-for="(item,i) in agentList"
                               :key="item.customerName1+i"
                               :label="item.customerName1"
                               :value="item.customerName1">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="省份" class="h-elformWrap-2" prop="province">
                  <el-select v-model="projectForm.province"
                             filterable clearable @change="handleItemChange1($event)"  placeholder="省">
                    <el-option
                            v-for="item in shenglist"
                            :key="item.value"
                            :label="item.name"
                            :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="地市" class="h-elformWrap-2" prop="city">
                  <el-select v-model="projectForm.city" filterable clearable placeholder="地市">
                    <el-option
                            v-for="item in cityList"
                            :key="item.name"
                            :label="item.name"
                            :value="item.name">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="渠道" class="h-elformWrap-2" prop="customerChannel">
                  <el-select v-model="projectForm.customerChannel" @change="changeChannelLoud" allow-create default-first-option clearable>
                    <el-option
                            v-for="item in chanlList"
                            :key="item.code"
                            :label="item.name"
                            :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>


                <el-form-item label="部门/科室" class="h-elformWrap-2" >
                  <el-input v-model="projectForm.deptName" placeholder="请输入部门/科室" />
                </el-form-item>

                <el-form-item label="负责人" class="h-elformWrap-2" >
                  <el-select v-model="projectForm.chargePerson"
                             @change="showCarryPerson"  filterable allow-create default-first-option clearable>
                    <el-option
                            v-for="item in bscLoudDeptPeople"
                            :key="item.contactPerson"
                            :label="item.contactPerson"
                            :value="item.contactPerson">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="联系电话" class="h-elformWrap-2" >
                  <el-input v-model="projectForm.phone" placeholder="请输入联系电话" />
                </el-form-item>
                <el-form-item label="小组长" class="h-elformWrap-2" v-if="projectForm.probjectSorts=='xm'">
                  <el-input v-model="projectForm.projectLeaderName" placeholder="请输入小组长" readonly/>
                </el-form-item>
                <el-form-item label="预估金额" class="h-elformWrap-2">
                  <el-input v-model="projectForm.estimatedAmount" :disabled="projectForm.estimatedAmount" placeholder="请输入预估金额" />
                </el-form-item>

              </el-collapse-item>
              <el-form-item label="是否投标" class="h-elformWrap-2" prop="isBid">
                <el-select v-model="projectForm.isBid" :clearable="true" @change="handleBidChange">
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="h-elformWrap-2" v-if="projectForm.isBid==1" style="width: 60%">
                <el-checkbox-group v-model="selectedValues" style="display: flex" @change="changeValue">
                  <el-checkbox v-for="(item,index) in optionsList" :label="item.code" :key="index">{{item.name}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>

            <!--  <el-form-item label="是否特价" class="h-elformWrap-2" prop="isSpecialOffer" v-if="projectForm.isBid==1&&projectForm.bidResult==1&&projectForm.statusR=='X4'">
                <el-select v-model="projectForm.isSpecialOffer" :clearable="true">
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="特价类型" class="h-elformWrap-2" prop="specialOfferType" v-if="projectForm.isSpecialOffer==1">
                <brselect
                    clearable
                    category="category_tejia"
                    :v="projectForm.specialOfferType"
                    v-model="projectForm.specialOfferType"
                >
                </brselect>


&lt;!&ndash;                <el-select v-model="projectForm.specialOfferType" :clearable="true">&ndash;&gt;
&lt;!&ndash;                  <el-option label="项目申请" value="0"></el-option>&ndash;&gt;
&lt;!&ndash;                  <el-option label="特殊直扣" value="1"></el-option>&ndash;&gt;
&lt;!&ndash;                  <el-option label="台阶政策" value="2"></el-option>&ndash;&gt;
&lt;!&ndash;                  <el-option label="高阶订单" value="3"></el-option>&ndash;&gt;
&lt;!&ndash;                </el-select>&ndash;&gt;
              </el-form-item>
              <el-form-item class="h-elformWrap-2" v-if="projectForm.isSpecialOffer==1">
               <el-button size="mini" type="primary" @click="handleApply">申请</el-button>
              </el-form-item>-->
              <!-- 是否投标 ---否-->
              <el-collapse-item name="X3" v-if="projectForm.isBid==0&&projectForm.isBid!=''">
                <template slot="title">
                  <span class="collapseTitle" :style="{color: activeStep=='X3'?'#0e75e9':''}">产品下单</span>
                  <i :class="activePanels.includes('X3')?'el-icon-arrow-down':'el-icon-arrow-right'"
                     style="margin-left: 4px;font-size: 14px;font-weight: 600" />
                </template>
                <el-form-item label="场景" v-if="projectForm.probjectSorts == 'xm'">
                  <brselect category="loud_scene" v-model="projectForm.scenesType" :v="projectForm.scenesType" :clearable="true"
                            @change="changeScenesType"
                  />
                </el-form-item>
                <div v-for="(product, index) in projectForm.products" :key="index" class="h-formBox product-item" >
                  <el-button
                          v-if="index === 0"
                          @click="addProduct()"
                          type="text"
                          size="mini"
                          style="float:right;font-size:20px;margin-right: -5px"
                          icon="el-icon-circle-plus"
                          circle
                          title="添加产品"
                  ></el-button>
                  <el-button
                          @click="deleteProduct(index)"
                          v-if="index !== 0"
                          type="text"
                          style="float:right;font-size:20px;margin-right: -5px;color:crimson;"
                          size="mini"
                          icon="el-icon-remove"
                          circle
                          title="删除产品"
                  ></el-button>
                  <el-form-item
                          v-if="projectForm.scenesType !== 2 && projectForm.scenesType !== '2'"
                          label="产品大类"
                          class="h-elformWrap-2"
                          :prop="`products[${index}].proLevelOne`"
                          :rules="[{ validator: (rule, value, callback) => validateProductField(rule, value, callback, index), trigger: 'blur' }]"
                  >
                    <el-input v-model="product.proLevelOne" placeholder="请输入产品大类" />
                  </el-form-item>
                  <el-form-item
                          v-if="projectForm.scenesType !== 2 && projectForm.scenesType !== '2'"
                          label="产品中类"
                          class="h-elformWrap-2"
                          :prop="`products[${index}].proLevelTwo`"
                          :rules="[{ validator: (rule, value, callback) => validateProductField(rule, value, callback, index), trigger: 'blur' }]"
                  >
                    <el-input v-model="product.proLevelTwo" placeholder="请输入产品中类" />
                  </el-form-item>
                  <el-form-item
                          label="产品型号" class="h-elformWrap-2"
                          :prop="`products[${index}].proModel`"
                          :rules="[{ validator: (rule, value, callback) => validateProductField(rule, value, callback, index), trigger: 'blur' }]"
                          v-if="projectForm.scenesType != 2">
                    <el-select v-model="projectForm.products[index].proModel" :title="projectForm.products[index].proModel" remoten
                               filterable placeholder="请输入"
                               @change="changeProducts($event,index)" :clearable="true">
                      <el-option v-for="(item) in projectForm.productByNameList"
                                 :key="item.proModel+'-'+item.proCode+item.djid"
                                 :label="item.proModel+'-'+item.proCode"
                                 :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                          v-if="projectForm.scenesType !== 2 && projectForm.scenesType !== '2'"
                          label="产品类型"
                          class="h-elformWrap-2"
                          :prop="`products[${index}].proType`"
                          :rules="formRules.proType"
                  >
                    <el-input v-model="product.proType" placeholder="请输入产品类型" />
                  </el-form-item>
                  <el-form-item
                          v-if="(projectForm.scenesType ==2)&&(projectForm.probjectSorts === 'xm')"
                          label="非标产品型号"
                          class="h-elformWrap-2"
                          :prop="`products[${index}].nosignProcode`"
                          :rules="formRules.nosignProcode"
                  >
                    <brselect category="crm_changjing_type" v-model="product.nosignProcode"
                              :v="product.nosignProcode" :clearable="true" />
                  </el-form-item>
                  <el-form-item
                          label="数量"
                          class="h-elformWrap-2"
                          :prop="`products[${index}].num`"
                          :rules="formRules.num"
                  >
                    <el-input v-model="product.num" placeholder="请输入数量" @change="changeNum(product,index)" type="number" />
                  </el-form-item>
                  <el-form-item
                          label="投标单价"
                          class="h-elformWrap-2"
                          :prop="`products[${index}].price`"
                          :rules="formRules.price"
                  >
                    <el-input v-model="product.price" placeholder="请输入投标单价" @change="changeNum(product,index)"  type="number" />
                  </el-form-item>
                  <el-form-item
                          label="投标总价"
                          class="h-elformWrap-2"
                  >
                    <el-input v-model="product.totalPrice" placeholder="投标总价" type="number" readonly/>
                  </el-form-item>
                </div >
                <div class="step-actions">
                  <el-button size="medium" @click="closeStep('')">关闭项目</el-button>
                  <el-button size="medium" type="primary" @click="submitStep()">完成</el-button>
                </div>


              </el-collapse-item>
              <!-- 是否投标 ---否end-->


              <!-- 是否投标 ---是-->
              <div v-if="projectForm.isBid==1">
                <!-- 项目设计 -->
                <el-collapse-item name="X1" v-if="selectedValues.includes('X1')">
                  <template slot="title">
                    <div style="display: flex;align-items: center" @click.stop>
                      <span class="collapseTitle" :style="{color: activeStep=='X1'?'#0e75e9':''}">项目设计</span>
                      <i :class="activePanels.includes('X1')?'el-icon-arrow-down':'el-icon-arrow-right'"
                         style="margin-left: 4px;font-size: 14px;font-weight: 600;line-height: 20px;pointer-events: auto;"
                         @click="togglePanel('X1')" />
                      <el-form-item label="设计到期时间" prop="dueDate" style="display: flex;margin-bottom: 0;margin-left: 20px">
                        <el-date-picker
                            v-model="projectForm.dueDate"
                            type="date"
                            placeholder="选择日期"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd"
                            @click.stop
                            clearable
                        />
                      </el-form-item>
                    </div>
                  </template>
                  <el-form-item label="场景" class="h-elformWrap-2" v-if="projectForm.probjectSorts === 'xm'" prop="designList[0].scenesType">
                    <brselect category="loud_scene" v-model="projectForm.designList[0].scenesType"
                              :v="projectForm.designList[0].scenesType" :clearable="true" @change="changeType"
                    />
                  </el-form-item>
                  <div v-for="(design, index) in projectForm.designList" :key="index" class="h-formBox product-item" >
                    <el-button
                        v-if="index === 0"
                        @click="addDesign()"
                        type="text"
                        size="mini"
                        style="float:right;font-size:20px;margin-right: -5px"
                        icon="el-icon-circle-plus"
                        circle
                        title="添加产品"
                    ></el-button>
                    <el-button
                        @click="deleteDesign(index)"
                        v-if="index !== 0"
                        type="text"
                        style="float:right;font-size:20px;margin-right: -5px;color:crimson;"
                        size="mini"
                        icon="el-icon-remove"
                        circle
                        title="删除产品"
                    ></el-button>
                    <el-form-item label="产品大类" class="h-elformWrap-2"
                                  :prop="`designList[${index}].proLevelOne`"
                                  :rules="[{ validator: (rule, value, callback) => validateDesignField(rule, value, callback, index), trigger: 'blur' }]"
                                  v-if="projectForm.designList[0].scenesType!=2">
                      <el-select v-model="design.proLevelOne"
                                 style="width: 100%;"
                                 placeholder="--请选择产品大类--" clearable @change="selectTwo(design.proLevelOne,index)">
                        <el-option v-for="item in oneList"
                                   :key="item.id"
                                   :label="item.levelname"
                                   :value="item.levelname">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="产品中类"
                                  class="h-elformWrap-2"
                                  :prop="`designList[${index}].proLevelTwo`"
                                  :rules="[{ validator: (rule, value, callback) => validateDesignField(rule, value, callback, index), trigger: 'blur' }]"
                                  v-if="projectForm.designList[0].scenesType!=2">
                      <el-select v-model="design.proLevelTwo"
                                 style="width: 100%;"
                                 placeholder="--请选择产品中类--" clearable>
                        <el-option v-for="item in design.twoList"
                                   :key="item.id"
                                   :label="item.levelname"
                                   :value="item.levelname">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="产品型号" class="h-elformWrap-2"
                                  :prop="`designList[${index}].proModel`"
                                  :rules="[{ validator: (rule, value, callback) => validateDesignField(rule, value, callback, index), trigger: 'blur' }]"
                                  v-if="projectForm.designList[0].scenesType!=2">
                      <el-select v-model="design.proModel"
                                 style="width: 100%;"
                                 remote filterable
                                 :filter-method="(query) => showProduct(query, index)"
                                 :remote-method="(query) => showProduct(query, index)"
                                  @change="(val) => showProduct(val, index, 'change')"
                                 placeholder="--请选择产品型号--" clearable>
                        <el-option v-for="item in proModelList"
                                   :key="item.id"
                                   :label="item.promodel+'-'+item.prodcode"
                                   :value="item.promodel">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="产品类型" class="h-elformWrap-2"
                                  :prop="`designList[${index}].proType`"
                                  :rules="formRules.proType"
                                  v-if="projectForm.designList[0].scenesType!=2">
                      <el-input v-model="design.proType" placeholder="请输入产品类型" />
                    </el-form-item>
                    <el-form-item label="非标产品型号" class="h-elformWrap-2"
                                  :prop="`designList[${index}].nosignProcode`"
                                  :rules="formRules.nosignProcode"
                                  v-if="projectForm.designList[0].scenesType==2">
                      <brselect category="crm_changjing_type" v-model="design.nosignProcode"
                                :v="design.nosignProcode" :clearable="true"/>
                    </el-form-item>
                    <el-form-item label="链群" class="h-elformWrap-2" :prop="`designList[${index}].lianqun`" :rules="formRules.lianqun">
                      <el-select v-model="design.lianqun"
                                 placeholder="请选择"  :v="design.lianqun" :clearable="true">
                        <el-option v-for="item in lianqunList" :key="item.code"
                                   :label="item.name" :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div >
                  <div class="step-actions">
                    <el-button size="medium" @click="closeStep('')">关闭项目</el-button>
                    <el-button size="medium" type="primary" @click="submitStep('X1','dueDate')">完成</el-button>

                    <el-button size="medium" type="primary" @click="contentdetails('X1','dueDate')">协同</el-button>
                  </div>
                </el-collapse-item>
                <!-- 项目立项 -->
                <el-collapse-item name="X2" v-if="selectedValues.includes('X2')">
                  <template slot="title">
                    <div @click="changexmlx" @click.stop style="display: flex;align-items: center">
                      <span class="collapseTitle" :style="{color: activeStep=='X2'?'#0e75e9':''}">项目立项</span>
                      <i :class="activePanels.includes('X2')?'el-icon-arrow-down':'el-icon-arrow-right'"
                         style="margin-left: 4px;font-size: 14px;font-weight: 600;line-height: 20px;pointer-events: auto;"
                         @click="togglePanel('X2')" />
                      <el-form-item label="立项到期时间" prop="designDueTime" style="display: flex;margin-bottom: 0;margin-left: 20px">
                        <el-date-picker
                                v-model="projectForm.designDueTime"
                                type="date"
                                placeholder="选择日期"
                                :picker-options="pickerOptions"
                                value-format="yyyy-MM-dd"
                                @click.stop
                        />
                      </el-form-item>
                    </div>
                  </template>
                  <div v-if="selectedValues.includes('X2')&&!(selectedValues.includes('X1'))">
                    <el-form-item label="场景" class="h-elformWrap-2" v-if="projectForm.probjectSorts === 'xm'" prop="designList[0].scenesType">
                      <brselect category="loud_scene" v-model="projectForm.designList[0].scenesType"
                                :v="projectForm.designList[0].scenesType" :clearable="true" @change="changeType"
                      />
                    </el-form-item>
                    <div v-for="(design, index) in projectForm.designList" :key="index" class="h-formBox product-item" >
                      <el-button
                          v-if="index === 0"
                          @click="addDesign()"
                          type="text"
                          size="mini"
                          style="float:right;font-size:20px;margin-right: -5px"
                          icon="el-icon-circle-plus"
                          circle
                          title="添加产品"
                      ></el-button>
                      <el-button
                          @click="deleteDesign(index)"
                          v-if="index !== 0"
                          type="text"
                          style="float:right;font-size:20px;margin-right: -5px;color:crimson;"
                          size="mini"
                          icon="el-icon-remove"
                          circle
                          title="删除产品"
                      ></el-button>
                      <el-form-item label="产品大类" class="h-elformWrap-2"
                                    :prop="`designList[${index}].proLevelOne`"
                                    :rules="[{ validator: (rule, value, callback) => validateDesignField(rule, value, callback, index), trigger: 'blur' }]"
                                    v-if="projectForm.designList[0].scenesType!=2">
                        <el-select v-model="design.proLevelOne"
                                   style="width: 100%;"
                                   placeholder="--请选择产品大类--" clearable @change="selectTwo(design.proLevelOne,index)">
                          <el-option v-for="item in oneList"
                                     :key="item.id"
                                     :label="item.levelname"
                                     :value="item.levelname">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="产品中类"
                                    class="h-elformWrap-2"
                                    :prop="`designList[${index}].proLevelTwo`"
                                    :rules="[{ validator: (rule, value, callback) => validateDesignField(rule, value, callback, index), trigger: 'blur' }]"
                                    v-if="projectForm.designList[0].scenesType!=2">
                        <el-select v-model="design.proLevelTwo"
                                   style="width: 100%;"
                                   placeholder="--请选择产品中类--" clearable>
                          <el-option v-for="item in design.twoList"
                                     :key="item.id"
                                     :label="item.levelname"
                                     :value="item.levelname">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="产品型号" class="h-elformWrap-2"
                                    :prop="`designList[${index}].proModel`"
                                    :rules="[{ validator: (rule, value, callback) => validateDesignField(rule, value, callback, index), trigger: 'blur' }]"
                                    v-if="projectForm.designList[0].scenesType!=2">
                        <el-select v-model="design.proModel"
                                   style="width: 100%;"
                                   remote filterable
                                   :filter-method="(query) => showProduct(query, index)"
                                   :remote-method="(query) => showProduct(query, index)"
                                   @change="(val) => showProduct(val, index, 'change')"
                                   placeholder="--请选择产品型号--" clearable>
                          <el-option v-for="item in proModelList"
                                     :key="item.id"
                                     :label="item.promodel+'-'+item.prodcode"
                                     :value="item.promodel">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="产品类型" class="h-elformWrap-2"
                                    :prop="`designList[${index}].proType`"
                                    :rules="formRules.proType"
                                    v-if="projectForm.designList[0].scenesType!=2">
                        <el-input v-model="design.proType" placeholder="请输入产品类型" />
                      </el-form-item>
                      <el-form-item label="非标产品型号" class="h-elformWrap-2"
                                    :prop="`designList[${index}].nosignProcode`"
                                    :rules="formRules.nosignProcode"
                                    v-if="projectForm.designList[0].scenesType==2">
                        <brselect category="crm_changjing_type" v-model="design.nosignProcode"
                                  :v="design.nosignProcode" :clearable="true"/>
                      </el-form-item>
                      <el-form-item label="链群" class="h-elformWrap-2" :prop="`designList[${index}].lianqun`" :rules="formRules.lianqun">
                        <el-select v-model="design.lianqun"
                                   placeholder="请选择"  :v="design.lianqun" :clearable="true">
                          <el-option v-for="item in lianqunList" :key="item.code"
                                     :label="item.name" :value="item.code">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </div >
                  </div>


                  <el-form-item label="跟单商类别" class="h-elformWrap-2" prop="documentaryType">
                    <brselect
                            category="gendanshang"
                            v-model="projectForm.documentaryType"
                            :clearable="true"
                            @change="handleDocumentaryTypeChange"
                            :v="projectForm.documentaryType"
                    />
                  </el-form-item>
                  <el-form-item label="经销商名称" class="h-elformWrap-2" prop="agentName" v-if="projectForm.documentaryType ==1">
                    <el-select v-model="projectForm.agentName" remote filterable :filter-method="showComList" clearable
                               placeholder="请输入"
                               :remote-method="showComList" @change="showComList">
                      <el-option v-for="(item,i) in agentList"
                                 :key="item.customerName1+i"
                                 :label="item.customerName1"
                                 :value="item.customerName1">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="合伙人名称" class="h-elformWrap-2" prop="partner" v-if="projectForm.documentaryType ==2">
                    <el-input v-model="projectForm.partner" placeholder="请输入合伙人名称" />
                  </el-form-item>
                  <div class="step-actions">
                    <el-button size="medium" @click="closeStep('')">关闭项目</el-button>
                    <el-button size="medium" type="primary" @click="submitStep('X2','designDueTime')">完成</el-button>
                    <el-button size="medium" type="primary" @click="contentdetails('X2','dueDate')">协同</el-button>
                  </div>
                </el-collapse-item>

                <!-- 项目投标 -->
                <el-collapse-item name="X3" v-if="selectedValues.includes('X3')">
                  <template slot="title">
                    <div style="display: flex;align-items: center" @click.stop>
                      <span class="collapseTitle" :style="{color: activeStep=='X3'?'#0e75e9':''}">项目投标</span>
                      <i :class="activePanels.includes('X3')?'el-icon-arrow-down':'el-icon-arrow-right'"
                         style="margin-left: 4px;font-size: 14px;font-weight: 600;line-height: 20px;pointer-events: auto;"
                         @click="togglePanel('X3')" />
                      <el-form-item label="投标到期时间"  prop="bidDueTime" style="display: flex;margin-bottom: 0;margin-left: 20px">
                        <el-date-picker
                            v-model="projectForm.bidDueTime"
                            type="date"
                            placeholder="选择日期"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd"
                            @click.stop
                        />
                      </el-form-item>
                    </div>
                  </template>

                  <div v-if="selectedValues.includes('X3')&&!(selectedValues.includes('X1'))&&!(selectedValues.includes('X2'))">
                    <div>
                      <el-form-item label="场景" class="h-elformWrap-2" v-if="projectForm.probjectSorts === 'xm'" prop="designList[0].scenesType">
                        <brselect category="loud_scene" v-model="projectForm.designList[0].scenesType"
                                  :v="projectForm.designList[0].scenesType" :clearable="true" @change="changeType"
                        />
                      </el-form-item>
                      <div v-for="(design, index) in projectForm.designList" :key="index" class="h-formBox product-item" >
                        <el-button
                            v-if="index === 0"
                            @click="addDesign()"
                            type="text"
                            size="mini"
                            style="float:right;font-size:20px;margin-right: -5px"
                            icon="el-icon-circle-plus"
                            circle
                            title="添加产品"
                        ></el-button>
                        <el-button
                            @click="deleteDesign(index)"
                            v-if="index !== 0"
                            type="text"
                            style="float:right;font-size:20px;margin-right: -5px;color:crimson;"
                            size="mini"
                            icon="el-icon-remove"
                            circle
                            title="删除产品"
                        ></el-button>
                        <el-form-item label="产品大类" class="h-elformWrap-2"
                                      :prop="`designList[${index}].proLevelOne`"
                                      :rules="[{ validator: (rule, value, callback) => validateDesignField(rule, value, callback, index), trigger: 'blur' }]"
                                      v-if="projectForm.designList[0].scenesType!=2">
                          <el-select v-model="design.proLevelOne"
                                     style="width: 100%;"
                                     placeholder="--请选择产品大类--" clearable @change="selectTwo(design.proLevelOne,index)">
                            <el-option v-for="item in oneList"
                                       :key="item.id"
                                       :label="item.levelname"
                                       :value="item.levelname">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="产品中类"
                                      class="h-elformWrap-2"
                                      :prop="`designList[${index}].proLevelTwo`"
                                      :rules="[{ validator: (rule, value, callback) => validateDesignField(rule, value, callback, index), trigger: 'blur' }]"
                                      v-if="projectForm.designList[0].scenesType!=2">
                          <el-select v-model="design.proLevelTwo"
                                     style="width: 100%;"
                                     placeholder="--请选择产品中类--" clearable>
                            <el-option v-for="item in design.twoList"
                                       :key="item.id"
                                       :label="item.levelname"
                                       :value="item.levelname">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="产品型号" class="h-elformWrap-2"
                                      :prop="`designList[${index}].proModel`"
                                      :rules="[{ validator: (rule, value, callback) => validateDesignField(rule, value, callback, index), trigger: 'blur' }]"
                                      v-if="projectForm.designList[0].scenesType!=2">
                          <el-select v-model="design.proModel"
                                     style="width: 100%;"
                                     remote filterable
                                     :filter-method="(query) => showProduct(query, index)"
                                     :remote-method="(query) => showProduct(query, index)"
                                     @change="(val) => showProduct(val, index, 'change')"
                                     placeholder="--请选择产品型号--" clearable>
                            <el-option v-for="item in proModelList"
                                       :key="item.id"
                                       :label="item.promodel+'-'+item.prodcode"
                                       :value="item.promodel">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="产品类型" class="h-elformWrap-2"
                                      :prop="`designList[${index}].proType`"
                                      :rules="formRules.proType"
                                      v-if="projectForm.designList[0].scenesType!=2">
                          <el-input v-model="design.proType" placeholder="请输入产品类型" />
                        </el-form-item>
                        <el-form-item label="非标产品型号" class="h-elformWrap-2"
                                      :prop="`designList[${index}].nosignProcode`"
                                      :rules="formRules.nosignProcode"
                                      v-if="projectForm.designList[0].scenesType==2">
                          <brselect category="crm_changjing_type" v-model="design.nosignProcode"
                                    :v="design.nosignProcode" :clearable="true"/>
                        </el-form-item>
                        <el-form-item label="链群" class="h-elformWrap-2" :prop="`designList[${index}].lianqun`" :rules="formRules.lianqun">
                          <el-select v-model="design.lianqun"
                                     placeholder="请选择"  :v="design.lianqun" :clearable="true">
                            <el-option v-for="item in lianqunList" :key="item.code"
                                       :label="item.name" :value="item.code">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div >
                    </div>
                    <el-form-item label="跟单商类别" class="h-elformWrap-2" prop="documentaryType">
                      <brselect
                              category="gendanshang"
                              v-model="projectForm.documentaryType"
                              :clearable="true"
                              @change="handleDocumentaryTypeChange"
                              :v="projectForm.documentaryType"
                      />
                    </el-form-item>
                    <el-form-item label="经销商名称" class="h-elformWrap-2" prop="agentName" v-if="projectForm.documentaryType ==1">
                      <el-select v-model="projectForm.agentName" remote filterable :filter-method="showComList" clearable
                                 placeholder="请输入"
                                 :remote-method="showComList" @change="showComList">
                        <el-option v-for="(item,i) in agentList"
                                   :key="item.customerName1+i"
                                   :label="item.customerName1"
                                   :value="item.customerName1">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="合伙人名称" class="h-elformWrap-2" prop="partner" v-if="projectForm.documentaryType ==2">
                      <el-input v-model="projectForm.partner" placeholder="请输入合伙人名称" />
                    </el-form-item>
                  </div>

                  <div v-if="selectedValues.includes('X3') && selectedValues.includes('X1') && !(selectedValues.includes('X2'))">
                    <el-form-item label="跟单商类别" class="h-elformWrap-2" prop="documentaryType">
                      <brselect
                              category="gendanshang"
                              v-model="projectForm.documentaryType"
                              :clearable="true"
                              @change="handleDocumentaryTypeChange"
                              :v="projectForm.documentaryType"
                      />
                    </el-form-item>
                    <el-form-item label="经销商名称" class="h-elformWrap-2" prop="agentName" v-if="projectForm.documentaryType ==1">
                      <el-select v-model="projectForm.agentName" remote filterable :filter-method="showComList" clearable
                                 placeholder="请输入"
                                 :remote-method="showComList" @change="showComList">
                        <el-option v-for="(item,i) in agentList"
                                   :key="item.customerName1+i"
                                   :label="item.customerName1"
                                   :value="item.customerName1">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="合伙人名称" class="h-elformWrap-2" prop="partner" v-if="projectForm.documentaryType ==2">
                      <el-input v-model="projectForm.partner" placeholder="请输入合伙人名称" />
                    </el-form-item>
                  </div>



                  <!--货物类-->
<!--                  <el-form-item label="投标时间" class="h-elformWrap-2" prop="bidTime">-->
<!--                    <el-date-picker-->
<!--                            v-model="projectForm.bidTime"-->
<!--                            type="date"-->
<!--                            placeholder="选择日期"-->
<!--                            :picker-options="pickerOptions"-->
<!--                            value-format="yyyy-MM-dd"-->
<!--                    ></el-date-picker>-->
<!--                  </el-form-item>-->
                  <el-form-item label="场景" class="h-elformWrap-2" prop="scenesType" v-if="projectForm.probjectSorts === 'xm'">
                    <brselect category="loud_scene" v-model="projectForm.scenesType"
                              :v="projectForm.scenesType" :clearable="true" @change="changeScenesType"
                    />
                  </el-form-item>
                  <!--                  <el-button type="primary" size="mini" @click="getProduct">获取产品</el-button>-->
                  <div v-for="(product, index) in projectForm.products" :key="index" class="h-formBox product-item" >
                    <el-button
                            v-if="index === 0"
                            @click="addProduct()"
                            type="text"
                            size="mini"
                            style="float:right;font-size:20px;margin-right: -5px"
                            icon="el-icon-circle-plus"
                            circle
                            title="添加产品"
                    ></el-button>
                    <el-button
                            @click="deleteProduct(index)"
                            v-if="index !== 0"
                            type="text"
                            style="float:right;font-size:20px;margin-right: -5px;color:crimson;"
                            size="mini"
                            icon="el-icon-remove"
                            circle
                            title="删除产品"
                    ></el-button>

                    <el-form-item
                            v-if="projectForm.scenesType !=2 "
                            label="产品大类"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].proLevelOne`"
                            :rules="[{ validator: (rule, value, callback) => validateProductField(rule, value, callback, index), trigger: 'blur' }]"
                    >
                      <el-input v-model="product.proLevelOne" placeholder="请输入产品大类" />
                    </el-form-item>
                    <el-form-item
                            v-if="projectForm.scenesType !=2"
                            label="产品中类"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].proLevelTwo`"
                            :rules="[{ validator: (rule, value, callback) => validateProductField(rule, value, callback, index), trigger: 'blur' }]"
                    >
                      <el-input v-model="product.proLevelTwo" placeholder="请输入产品中类" />
                    </el-form-item>

                    <el-form-item
                            label="产品型号" class="h-elformWrap-2"
                            :prop="`products[${index}].proModel`"
                            :rules="[{ validator: (rule, value, callback) => validateProductField(rule, value, callback, index), trigger: 'blur' }]"
                            v-if="projectForm.scenesType != 2">
                      <el-select v-model="projectForm.products[index].proModel" :title="projectForm.products[index].proModel" remoten
                                 filterable placeholder="请输入"
                                 @change="changeProducts($event,index)" :clearable="true">
                        <el-option v-for="(item) in projectForm.productByNameList"
                                   :key="item.proModel+'-'+item.proCode+item.djid"
                                   :label="item.proModel+'-'+item.proCode"
                                   :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item
                            v-if="projectForm.scenesType !=2"
                            label="产品类型"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].proType`"
                            :rules="formRules.proType"
                    >
                      <el-input v-model="product.proType" placeholder="请输入产品类型" />
                    </el-form-item>

                    <el-form-item
                            v-if="(projectForm.scenesType ==2)&&(projectForm.probjectSorts === 'xm')"
                            label="非标产品型号"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].nosignProcode`"
                            :rules="formRules.nosignProcode"
                    >
                      <brselect category="crm_changjing_type" v-model="product.nosignProcode"
                                :v="product.nosignProcode" :clearable="true"/>
                    </el-form-item>

                    <el-form-item
                            label="数量"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].num`"
                            :rules="formRules.num"
                    >
                      <el-input v-model="product.num" placeholder="请输入数量" @change="changeNum(product,index)" type="number" />
                    </el-form-item>

                    <el-form-item
                            label="投标单价"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].price`"
                            :rules="formRules.price"
                    >
                      <el-input v-model="product.price" placeholder="请输入投标单价" @change="changeNum(product,index)" type="number" />
                    </el-form-item>

                    <el-form-item
                            label="投标总价"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].totalPrice`"
                            :rules="formRules.totalPrice"
                    >
                      <el-input v-model="product.totalPrice" placeholder="投标总价" type="number" readonly/>
                    </el-form-item>
                  </div >

                  <div class="step-actions">
                    <el-button size="medium" @click="closeStep('')">关闭项目</el-button>
                    <el-button size="medium" type="primary" @click="submitStep('X3','bidDueTime')">完成</el-button>
                    <el-button size="medium" type="primary" @click="contentdetails('X3','dueDate')">协同</el-button>
                  </div>
                </el-collapse-item>

                <!-- 中标签约 -->
                <el-collapse-item name="X4" v-if="selectedValues.includes('X4')">
                  <template slot="title">
                    <div style="display:flex;align-items: center" @click.stop>
                      <span class="collapseTitle" :style="{color: activeStep=='X4'?'#0e75e9':''}">中标签约</span>
                      <i :class="activePanels.includes('X4')?'el-icon-arrow-down':'el-icon-arrow-right'"
                         style="margin-left: 4px;font-size: 14px;font-weight: 600;line-height: 20px;pointer-events: auto;"
                         @click="togglePanel('X4')" />
                      <el-form-item label="用户合同签约到期时间"  prop="signDueTime" style="display: flex; margin-bottom: 0;margin-left: 20px">
                        <el-date-picker
                            v-model="projectForm.signDueTime"
                            type="date"
                            placeholder="选择日期"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd"
                            @click.stop
                        />
                      </el-form-item>
                    </div>
                  </template>
                  <!--                  // 如果不选择1、2、3，那么就是只选4// 如果不选2、3，选了1，那么4里面包含2、3，，，如果选了2不选1、3，那么3在4里面显示-->


                  <!--                  如果只选择了中标签约，那么在中标签约里展示所有，如果选择了项目投标和签约，那么不需要操作，如果不选择项目投标，那么项目投标和签约在签约里展示-->
                  <!--                  selectedValues.includes('X4')&&!(selectedValues.includes('X1'))&&!(selectedValues.includes('X2'))&&!(selectedValues.includes('X3'))-->
                  <!--                  selectedValues.includes('X4')&&!(selectedValues.includes('X3'))-->

                  <div v-if="selectedValues.includes('X4')&&!(selectedValues.includes('X1'))&&!(selectedValues.includes('X2'))&&!(selectedValues.includes('X3'))">
                    <!--项目设计-->
                    <div>
                      <el-form-item label="场景" class="h-elformWrap-2" v-if="projectForm.probjectSorts === 'xm'" prop="designList[0].scenesType">
                        <brselect category="loud_scene" v-model="projectForm.designList[0].scenesType"
                                  :v="projectForm.designList[0].scenesType" :clearable="true" @change="changeType"
                        />
                      </el-form-item>
                      <div v-for="(design, index) in projectForm.designList" :key="index" class="h-formBox product-item" >
                        <el-button
                            v-if="index === 0"
                            @click="addDesign()"
                            type="text"
                            size="mini"
                            style="float:right;font-size:20px;margin-right: -5px"
                            icon="el-icon-circle-plus"
                            circle
                            title="添加产品"
                        ></el-button>
                        <el-button
                            @click="deleteDesign(index)"
                            v-if="index !== 0"
                            type="text"
                            style="float:right;font-size:20px;margin-right: -5px;color:crimson;"
                            size="mini"
                            icon="el-icon-remove"
                            circle
                            title="删除产品"
                        ></el-button>
                        <el-form-item label="产品大类" class="h-elformWrap-2"
                                      :prop="`designList[${index}].proLevelOne`"
                                      :rules="[{ validator: (rule, value, callback) => validateDesignField(rule, value, callback, index), trigger: 'blur' }]"
                                      v-if="projectForm.designList[0].scenesType!=2">
                          <el-select v-model="design.proLevelOne"
                                     style="width: 100%;"
                                     placeholder="--请选择产品大类--" clearable @change="selectTwo(design.proLevelOne,index)">
                            <el-option v-for="item in oneList"
                                       :key="item.id"
                                       :label="item.levelname"
                                       :value="item.levelname">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="产品中类"
                                      class="h-elformWrap-2"
                                      :prop="`designList[${index}].proLevelTwo`"
                                      :rules="[{ validator: (rule, value, callback) => validateDesignField(rule, value, callback, index), trigger: 'blur' }]"
                                      v-if="projectForm.designList[0].scenesType!=2">
                          <el-select v-model="design.proLevelTwo"
                                     style="width: 100%;"
                                     placeholder="--请选择产品中类--" clearable>
                            <el-option v-for="item in design.twoList"
                                       :key="item.id"
                                       :label="item.levelname"
                                       :value="item.levelname">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="产品型号" class="h-elformWrap-2"
                                      :prop="`designList[${index}].proModel`"
                                      :rules="[{ validator: (rule, value, callback) => validateDesignField(rule, value, callback, index), trigger: 'blur' }]"
                                      v-if="projectForm.designList[0].scenesType!=2">
                          <el-select v-model="design.proModel"
                                     style="width: 100%;"
                                     remote filterable
                                     :filter-method="(query) => showProduct(query, index)"
                                     :remote-method="(query) => showProduct(query, index)"
                                     @change="(val) => showProduct(val, index, 'change')"
                                     placeholder="--请选择产品型号--" clearable>
                            <el-option v-for="item in proModelList"
                                       :key="item.id"
                                       :label="item.promodel+'-'+item.prodcode"
                                       :value="item.promodel">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="产品类型" class="h-elformWrap-2"
                                      :prop="`designList[${index}].proType`"
                                      :rules="formRules.proType"
                                      v-if="projectForm.designList[0].scenesType!=2">
                          <el-input v-model="design.proType" placeholder="请输入产品类型" />
                        </el-form-item>
                        <el-form-item label="非标产品型号" class="h-elformWrap-2"
                                      :prop="`designList[${index}].nosignProcode`"
                                      :rules="formRules.nosignProcode"
                                      v-if="projectForm.designList[0].scenesType==2">
                          <brselect category="crm_changjing_type" v-model="design.nosignProcode"
                                    :v="design.nosignProcode" :clearable="true"/>
                        </el-form-item>
                        <el-form-item label="链群" class="h-elformWrap-2" :prop="`designList[${index}].lianqun`" :rules="formRules.lianqun">
                          <el-select v-model="design.lianqun"
                                     placeholder="请选择"  :v="design.lianqun" :clearable="true">
                            <el-option v-for="item in lianqunList" :key="item.code"
                                       :label="item.name" :value="item.code">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div >
                    </div>
                    <!--项目立项-->
                    <div>
                      <el-form-item label="跟单商类别" class="h-elformWrap-2" prop="documentaryType">
                        <brselect
                            category="gendanshang"
                            v-model="projectForm.documentaryType"
                            :clearable="true"
                            @change="handleDocumentaryTypeChange"
                            :v="projectForm.documentaryType"
                        />
                      </el-form-item>
                      <el-form-item label="经销商名称" class="h-elformWrap-2" prop="agentName" v-if="projectForm.documentaryType ==1">
                        <el-select v-model="projectForm.agentName" remote filterable :filter-method="showComList" clearable
                                   placeholder="请输入"
                                   :remote-method="showComList" @change="showComList">
                          <el-option v-for="(item,i) in agentList"
                                     :key="item.customerName1+i"
                                     :label="item.customerName1"
                                     :value="item.customerName1">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="合伙人名称" class="h-elformWrap-2" prop="partner" v-if="projectForm.documentaryType ==2">
                        <el-input v-model="projectForm.partner" placeholder="请输入合伙人名称" />
                      </el-form-item>
                    </div>
                    <!--项目投标-->
                    <div>
<!--                      <el-form-item label="投标时间" class="h-elformWrap-2" prop="bidTime">-->
<!--                        <el-date-picker-->
<!--                            v-model="projectForm.bidTime"-->
<!--                            type="date"-->
<!--                            placeholder="选择日期"-->
<!--                            :picker-options="pickerOptions"-->
<!--                            value-format="yyyy-MM-dd"-->
<!--                        ></el-date-picker>-->
<!--                      </el-form-item>-->
                      <el-form-item label="场景" class="h-elformWrap-2" prop="scenesType" v-if="projectForm.probjectSorts === 'xm'">
                        <brselect category="loud_scene" v-model="projectForm.scenesType"
                                  :v="projectForm.scenesType" :clearable="true" @change="changeScenesType"
                        />
                      </el-form-item>
                      <div v-for="(product, index) in projectForm.products" :key="index" class="h-formBox product-item" >
                        <el-button
                            v-if="index === 0"
                            @click="addProduct()"
                            type="text"
                            size="mini"
                            style="float:right;font-size:20px;margin-right: -5px"
                            icon="el-icon-circle-plus"
                            circle
                            title="添加产品"
                        ></el-button>
                        <el-button
                            @click="deleteProduct(index)"
                            v-if="index !== 0"
                            type="text"
                            style="float:right;font-size:20px;margin-right: -5px;color:crimson;"
                            size="mini"
                            icon="el-icon-remove"
                            circle
                            title="删除产品"
                        ></el-button>

                        <el-form-item
                            v-if="projectForm.scenesType !=2 "
                            label="产品大类"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].proLevelOne`"
                            :rules="[{ validator: (rule, value, callback) => validateProductField(rule, value, callback, index), trigger: 'blur' }]"
                        >
                          <el-input v-model="product.proLevelOne" placeholder="请输入产品大类" />
                        </el-form-item>
                        <el-form-item
                            v-if="projectForm.scenesType !=2"
                            label="产品中类"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].proLevelTwo`"
                            :rules="[{ validator: (rule, value, callback) => validateProductField(rule, value, callback, index), trigger: 'blur' }]"
                        >
                          <el-input v-model="product.proLevelTwo" placeholder="请输入产品中类" />
                        </el-form-item>

                        <el-form-item
                            label="产品型号" class="h-elformWrap-2"
                            :prop="`products[${index}].proModel`"
                            :rules="[{ validator: (rule, value, callback) => validateProductField(rule, value, callback, index), trigger: 'blur' }]"
                            v-if="projectForm.scenesType != 2">
                          <el-select v-model="projectForm.products[index].proModel" :title="projectForm.products[index].proModel" remoten
                                     filterable placeholder="请输入"
                                     @change="changeProducts($event,index)" :clearable="true">
                            <el-option v-for="(item) in projectForm.productByNameList"
                                       :key="item.proModel+'-'+item.proCode+item.djid"
                                       :label="item.proModel+'-'+item.proCode"
                                       :value="item">
                            </el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item
                            v-if="projectForm.scenesType !=2"
                            label="产品类型"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].proType`"
                            :rules="formRules.proType"
                        >
                          <el-input v-model="product.proType" placeholder="请输入产品类型" />
                        </el-form-item>

                        <el-form-item
                            v-if="(projectForm.scenesType ==2)&&(projectForm.probjectSorts === 'xm')"
                            label="非标产品型号"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].nosignProcode`"
                            :rules="formRules.nosignProcode"
                        >
                          <brselect category="crm_changjing_type" v-model="product.nosignProcode"
                                    :v="product.nosignProcode" :clearable="true"/>
                        </el-form-item>

                        <el-form-item
                            label="数量"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].num`"
                            :rules="formRules.num"
                        >
                          <el-input v-model="product.num" placeholder="请输入数量" @change="changeNum(product,index)" type="number" />
                        </el-form-item>

                        <el-form-item
                            label="投标单价"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].price`"
                            :rules="formRules.price"
                        >
                          <el-input v-model="product.price" placeholder="请输入投标单价" @change="changeNum(product,index)" type="number" />
                        </el-form-item>

                        <el-form-item
                            label="投标总价"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].totalPrice`"
                            :rules="formRules.totalPrice"
                        >
                          <el-input v-model="product.totalPrice" placeholder="投标总价" type="number" readonly/>
                        </el-form-item>
                      </div >
                    </div>
                  </div>
                  <div v-if="selectedValues.includes('X4')&&!(selectedValues.includes('X3'))&&selectedValues.includes('X2')">
                    <!--项目投标-->
<!--                    <el-form-item label="投标时间" class="h-elformWrap-2" prop="bidTime">-->
<!--                      <el-date-picker-->
<!--                          v-model="projectForm.bidTime"-->
<!--                          type="date"-->
<!--                          placeholder="选择日期"-->
<!--                          :picker-options="pickerOptions"-->
<!--                          value-format="yyyy-MM-dd"-->
<!--                      ></el-date-picker>-->
<!--                    </el-form-item>-->
                    <el-form-item label="场景" class="h-elformWrap-2" prop="scenesType" v-if="projectForm.probjectSorts === 'xm'">
                      <brselect category="loud_scene" v-model="projectForm.scenesType"
                                :v="projectForm.scenesType" :clearable="true" @change="changeScenesType"
                      />
                    </el-form-item>
                    <div v-for="(product, index) in projectForm.products" :key="index" class="h-formBox product-item" >
                      <el-button
                          v-if="index === 0"
                          @click="addProduct()"
                          type="text"
                          size="mini"
                          style="float:right;font-size:20px;margin-right: -5px"
                          icon="el-icon-circle-plus"
                          circle
                          title="添加产品"
                      ></el-button>
                      <el-button
                          @click="deleteProduct(index)"
                          v-if="index !== 0"
                          type="text"
                          style="float:right;font-size:20px;margin-right: -5px;color:crimson;"
                          size="mini"
                          icon="el-icon-remove"
                          circle
                          title="删除产品"
                      ></el-button>

                      <el-form-item
                          v-if="projectForm.scenesType !=2 "
                          label="产品大类"
                          class="h-elformWrap-2"
                          :prop="`products[${index}].proLevelOne`"
                          :rules="[{ validator: (rule, value, callback) => validateProductField(rule, value, callback, index), trigger: 'blur' }]"
                      >
                        <el-input v-model="product.proLevelOne" placeholder="请输入产品大类" />
                      </el-form-item>
                      <el-form-item
                          v-if="projectForm.scenesType !=2"
                          label="产品中类"
                          class="h-elformWrap-2"
                          :prop="`products[${index}].proLevelTwo`"
                          :rules="[{ validator: (rule, value, callback) => validateProductField(rule, value, callback, index), trigger: 'blur' }]"
                      >
                        <el-input v-model="product.proLevelTwo" placeholder="请输入产品中类" />
                      </el-form-item>

                      <el-form-item
                          label="产品型号" class="h-elformWrap-2"
                          :prop="`products[${index}].proModel`"
                          :rules="[{ validator: (rule, value, callback) => validateProductField(rule, value, callback, index), trigger: 'blur' }]"
                          v-if="projectForm.scenesType != 2">
                        <el-select v-model="projectForm.products[index].proModel" :title="projectForm.products[index].proModel" remoten
                                   filterable placeholder="请输入"
                                   @change="changeProducts($event,index)" :clearable="true">
                          <el-option v-for="(item) in projectForm.productByNameList"
                                     :key="item.proModel+'-'+item.proCode+item.djid"
                                     :label="item.proModel+'-'+item.proCode"
                                     :value="item">
                          </el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item
                          v-if="projectForm.scenesType !=2"
                          label="产品类型"
                          class="h-elformWrap-2"
                          :prop="`products[${index}].proType`"
                          :rules="formRules.proType"
                      >
                        <el-input v-model="product.proType" placeholder="请输入产品类型" />
                      </el-form-item>

                      <el-form-item
                          v-if="(projectForm.scenesType ==2)&&(projectForm.probjectSorts === 'xm')"
                          label="非标产品型号"
                          class="h-elformWrap-2"
                          :prop="`products[${index}].nosignProcode`"
                          :rules="formRules.nosignProcode"
                      >
                        <brselect category="crm_changjing_type" v-model="product.nosignProcode"
                                  :v="product.nosignProcode" :clearable="true"/>
                      </el-form-item>

                      <el-form-item
                          label="数量"
                          class="h-elformWrap-2"
                          :prop="`products[${index}].num`"
                          :rules="formRules.num"
                      >
                        <el-input v-model="product.num" placeholder="请输入数量" @change="changeNum(product,index)" type="number" />
                      </el-form-item>

                      <el-form-item
                          label="投标单价"
                          class="h-elformWrap-2"
                          :prop="`products[${index}].price`"
                          :rules="formRules.price"
                      >
                        <el-input v-model="product.price" placeholder="请输入投标单价" @change="changeNum(product,index)" type="number" />
                      </el-form-item>

                      <el-form-item
                          label="投标总价"
                          class="h-elformWrap-2"
                          :prop="`products[${index}].totalPrice`"
                          :rules="formRules.totalPrice"
                      >
                        <el-input v-model="product.totalPrice" placeholder="投标总价" type="number" readonly/>
                      </el-form-item>
                    </div >
                  </div>
                  <div v-if="selectedValues.includes('X4')&&!(selectedValues.includes('X3'))&&!(selectedValues.includes('X2'))&&selectedValues.includes('X1')">
                    <!--项目立项-->
                    <div>
                      <el-form-item label="跟单商类别" class="h-elformWrap-2" prop="documentaryType">
                        <brselect
                            category="gendanshang"
                            v-model="projectForm.documentaryType"
                            :clearable="true"
                            @change="handleDocumentaryTypeChange"
                            :v="projectForm.documentaryType"
                        />
                      </el-form-item>
                      <el-form-item label="经销商名称" class="h-elformWrap-2" prop="agentName" v-if="projectForm.documentaryType ==1">
                        <el-select v-model="projectForm.agentName" remote filterable :filter-method="showComList" clearable
                                   placeholder="请输入"
                                   :remote-method="showComList" @change="showComList">
                          <el-option v-for="(item,i) in agentList"
                                     :key="item.customerName1+i"
                                     :label="item.customerName1"
                                     :value="item.customerName1">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="合伙人名称" class="h-elformWrap-2" prop="partner" v-if="projectForm.documentaryType ==2">
                        <el-input v-model="projectForm.partner" placeholder="请输入合伙人名称" />
                      </el-form-item>
                    </div>
                    <!--项目投标-->
                    <div>
<!--                      <el-form-item label="投标时间" class="h-elformWrap-2" prop="bidTime">-->
<!--                        <el-date-picker-->
<!--                            v-model="projectForm.bidTime"-->
<!--                            type="date"-->
<!--                            placeholder="选择日期"-->
<!--                            :picker-options="pickerOptions"-->
<!--                            value-format="yyyy-MM-dd"-->
<!--                        ></el-date-picker>-->
<!--                      </el-form-item>-->
                      <el-form-item label="场景" class="h-elformWrap-2" prop="scenesType" v-if="projectForm.probjectSorts === 'xm'">
                        <brselect category="loud_scene" v-model="projectForm.scenesType"
                                  :v="projectForm.scenesType" :clearable="true" @change="changeScenesType"
                        />
                      </el-form-item>
                      <div v-for="(product, index) in projectForm.products" :key="index" class="h-formBox product-item" >
                        <el-button
                            v-if="index === 0"
                            @click="addProduct()"
                            type="text"
                            size="mini"
                            style="float:right;font-size:20px;margin-right: -5px"
                            icon="el-icon-circle-plus"
                            circle
                            title="添加产品"
                        ></el-button>
                        <el-button
                            @click="deleteProduct(index)"
                            v-if="index !== 0"
                            type="text"
                            style="float:right;font-size:20px;margin-right: -5px;color:crimson;"
                            size="mini"
                            icon="el-icon-remove"
                            circle
                            title="删除产品"
                        ></el-button>

                        <el-form-item
                            v-if="projectForm.scenesType !=2 "
                            label="产品大类"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].proLevelOne`"
                            :rules="[{ validator: (rule, value, callback) => validateProductField(rule, value, callback, index), trigger: 'blur' }]"
                        >
                          <el-input v-model="product.proLevelOne" placeholder="请输入产品大类" />
                        </el-form-item>
                        <el-form-item
                            v-if="projectForm.scenesType !=2"
                            label="产品中类"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].proLevelTwo`"
                            :rules="[{ validator: (rule, value, callback) => validateProductField(rule, value, callback, index), trigger: 'blur' }]"
                        >
                          <el-input v-model="product.proLevelTwo" placeholder="请输入产品中类" />
                        </el-form-item>

                        <el-form-item
                            label="产品型号" class="h-elformWrap-2"
                            :prop="`products[${index}].proModel`"
                            :rules="[{ validator: (rule, value, callback) => validateProductField(rule, value, callback, index), trigger: 'blur' }]"
                            v-if="projectForm.scenesType != 2">
                          <el-select v-model="projectForm.products[index].proModel" :title="projectForm.products[index].proModel" remoten
                                     filterable placeholder="请输入"
                                     @change="changeProducts($event,index)" :clearable="true">
                            <el-option v-for="(item) in projectForm.productByNameList"
                                       :key="item.proModel+'-'+item.proCode+item.djid"
                                       :label="item.proModel+'-'+item.proCode"
                                       :value="item">
                            </el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item
                            v-if="projectForm.scenesType !=2"
                            label="产品类型"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].proType`"
                            :rules="formRules.proType"
                        >
                          <el-input v-model="product.proType" placeholder="请输入产品类型" />
                        </el-form-item>

                        <el-form-item
                            v-if="(projectForm.scenesType ==2)&&(projectForm.probjectSorts === 'xm')"
                            label="非标产品型号"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].nosignProcode`"
                            :rules="formRules.nosignProcode"
                        >
                          <brselect category="crm_changjing_type" v-model="product.nosignProcode"
                                    :v="product.nosignProcode" :clearable="true"/>
                        </el-form-item>

                        <el-form-item
                            label="数量"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].num`"
                            :rules="formRules.num"
                        >
                          <el-input v-model="product.num" placeholder="请输入数量" @change="changeNum(product,index)" type="number" />
                        </el-form-item>

                        <el-form-item
                            label="投标单价"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].price`"
                            :rules="formRules.price"
                        >
                          <el-input v-model="product.price" placeholder="请输入投标单价" @change="changeNum(product,index)" type="number" />
                        </el-form-item>

                        <el-form-item
                            label="投标总价"
                            class="h-elformWrap-2"
                            :prop="`products[${index}].totalPrice`"
                            :rules="formRules.totalPrice"
                        >
                          <el-input v-model="product.totalPrice" placeholder="投标总价" type="number" readonly/>
                        </el-form-item>
                      </div >
                    </div>
                  </div>
                  <el-form-item label="开标结果" class="h-elformWrap-2" prop="bidResult">
                    <el-select v-model="projectForm.bidResult" placeholder="请选择" @change="changeResult" clearable>
                      <el-option
                              v-for="item in bidResultOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="用户单位" class="h-elformWrap-2" :transfer="true">
                    <el-select v-model="projectForm.customerName" remote filterable :transfer="true" :filter-method="showGroupList" :clearable="true"
                               placeholder="请输入" :popper-append-to-body="false" style="width: 90%"
                               :remote-method="showGroupList" @change="showGroupList" >
                      <el-option v-for="(item,index) in customerNameList"
                                 :key="index"
                                 :label="item.deptName"
                                 :value="item.deptName">
                      </el-option>
                    </el-select>
                    <i class="el-icon-circle-plus" @click="createAddress" style="cursor: pointer"/>
                  </el-form-item>
                  <el-form-item label="预计下单时间" class="h-elformWrap-2" prop="expOnlineDate" v-if="projectForm.bidResult === 1 || projectForm.bidResult === '1'">
                    <el-date-picker
                            v-model="projectForm.expOnlineDate"
                            type="date"
                            placeholder="选择日期"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                  <el-form-item label="丢标原因" class="h-elformWrap-2" prop="delReason" v-if="projectForm.bidResult === 2||projectForm.bidResult === '2'">
                    <el-input v-model="projectForm.delReason" placeholder="请输入丢标原因" clearable/>
                  </el-form-item>

                  <div class="step-actions">
                    <el-button size="medium" @click="closeStep('')">关闭项目</el-button>
                    <el-button size="medium" type="primary" @click="submitStep('X4','signDueTime')">完成</el-button>
                    <el-button size="medium" type="primary" @click="contentdetails('X4','dueDate')">协同</el-button>
                  </div>
                </el-collapse-item>

                <!-- 中标签约 -->
                <el-collapse-item name="tj" v-if="projectForm.isBid==1&&projectForm.bidResult==1&&projectForm.statusR=='X4'">
                  <template slot="title">
                    <div style="display:flex;align-items: center" @click.stop>
                      <span class="collapseTitle" :style="{color: activeStep=='tj'?'#0e75e9':''}">价格申请</span>
                      <i :class="activePanels.includes('tj')?'el-icon-arrow-down':'el-icon-arrow-right'"
                         style="margin-left: 4px;font-size: 14px;font-weight: 600;line-height: 20px;pointer-events: auto;"
                         @click="togglePanel('tj')" />
                    </div>
                  </template>

                  <el-form-item label="是否特价" class="h-elformWrap-2" prop="isSpecialOffer" v-if="projectForm.isBid==1&&projectForm.bidResult==1&&projectForm.statusR=='X4'">
                    <el-select v-model="projectForm.isSpecialOffer" :clearable="true">
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="特价类型" class="h-elformWrap-2" prop="specialOfferType" v-if="projectForm.isSpecialOffer==1">
                    <brselect
                            clearable
                            category="category_tejia"
                            :v="projectForm.specialOfferType"
                            v-model="projectForm.specialOfferType"
                    >
                    </brselect>
                  </el-form-item>
                  <el-form-item class="h-elformWrap-2" v-if="projectForm.isSpecialOffer==1">
                    <el-button size="mini" type="primary" @click="handleApply">申请</el-button>
                  </el-form-item>

                </el-collapse-item>

              </div>

            </el-collapse>
          </div>

          <!-- 表单操作按钮 -->
          <!--          <div class="form-actions">-->
          <!--            <el-button @click="resetForm">返回</el-button>-->
          <!--            <el-button type="primary" @click="validateForm" :loading="subLoad">确认提交</el-button>-->
          <!--          </div>-->
        </el-form>
      </div>
    </div>
    <!-- 新建用户单位 -->
    <el-dialog :close-on-click-modal="false"  @close='closeDialogUser' :visible.sync="institutionalX" class="h-dialog2">
      <companyName ref="companyName" :titleName = "titleDig" :add1 = "addUser" :stVal="stVal" @getChildValue="closeCompanyName" />
    </el-dialog>

<!--    关闭项目填写理由-->
    <el-dialog :visible.sync="closeProjectModal" @close="handleCloseProject" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>关闭项目</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
          <div style="padding: 12px;" class="dialogout X-dai">
            <el-form ref="form" :model="closeForm" label-position="right" :inline="true" label-width="130"
                     class="demo-ruleForm h-formbLine h-formbnpm Line1">
              <el-form-item label="关闭原因" class="h-elformWrap-1"  prop="reason"
                            :rules="[{ required: true, message: '请输入关闭原因', trigger: 'blur'}]">
                <el-input v-model="closeForm.reason" clearable type="textarea" :rows="2" resize="none"></el-input>
              </el-form-item>
              <el-form-item label="说明" class="h-elformWrap-1" prop="note">
                <el-input v-model="closeForm.note"  clearable type="textarea" :rows="2" resize="none" style="width: 100%;"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="handleCloseProject()">取消</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submitProjectModal()">提交</el-button>
          </div>
        </div>
    </el-dialog>

    <!--新增信息漏斗协同-->
    <el-dialog :close-on-click-modal="false" :visible.sync="contentdetailsAdd" class="h-dialog2 yonghu" @close="cancelXt()">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>新增协同</h1>
            <p>New</p>
          </div>
        </div>
      </div>
      <div class="h-formLine h-mrb-38">
        <el-form
                :model="formModel"
                :rules="rules"
                ref="formRef"
                inline
                class="demo-ruleForm h-formbLine h-dialogForm dialogForms"
                label-width="90px"
        >
          <!-- 表单头部 -->
          <div class="form-header">
            <el-button
                    @click="addXtUser()"
                    type="text"
                    size="mini"
                    icon="el-icon-circle-plus"
                    circle
                    class="add-btn"
                    tooltip="添加协同用户"
            ></el-button>
          </div>

          <!-- 循环表单项 -->
          <div
                  v-for="(listIt, index) in formModel.loudContent"
                  :key="`xt-user-${index}-${listIt.contentCode || Date.now()}`"
                  class="h-formBox form-item-wrap"
          >
            <!-- 删除按钮 -->
            <el-button
                    @click="deleteXtUser(index)"
                    v-show="formModel.loudContent.length > 1"
                    type="text"
                    size="mini"
                    icon="el-icon-remove"
                    circle
                    class="delete-btn"
                    tooltip="删除当前行"
            ></el-button>

            <!-- 用户名称 -->
            <el-form-item
                    label="用户名称"
                    :prop="`loudContent.${index}.contentName`"
                    :rules="rules.contentName"
            >
              <el-select
                      v-model="listIt.contentName"
                      remote
                      filterable
                      :filter-method="(val) => showUserList(val, index)"
                      :remote-method="(val) => showUserList(val, index)"
                      @change="(val) => handleUserChange(val, index)"
                      placeholder="请输入用户名称搜索"
                      clearable
                      ref="usercodeRefs"
                      :disabled="listIt.disabled"
              >
                <el-option
                        v-for="(item, itemIndex) in userList"
                        :key="`user-option-${item.usercode || itemIndex}`"
                        :label="`${item.username}-${item.usercode}`"
                        :value="`${item.username}-${item.usercode}`"
                ></el-option>
              </el-select>
            </el-form-item>

            <!-- 用户编码 -->
            <el-form-item
                    label="用户编码"
            >
              <el-input
                      v-model="listIt.contentCode"
                      placeholder="选择用户后自动带出"
                      disabled
                      clearable
              ></el-input>
            </el-form-item>

            <!-- 协同问题 -->
            <el-form-item
                    label="协同问题"
                    :prop="`loudContent.${index}.contentMsg`"
                    :rules="rules.contentMsg"
                    class="h-elformWrap-1"
            >
              <el-input
                      v-model="listIt.contentMsg"
                      placeholder="请输入协同问题描述"
                      type="textarea"
                      :rows="2"
                      resize="vertical"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-formBtn h-bgwhite" @click="cancelXt('f')">取消</el-button>
        <el-button class="h-btn h-formBtn h-bgblueQ2" @click="insertXt(1)">提交
        </el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import ss from "@/api/SystemService";
  import _ from "loadsh";
  import companyName from "./companyNameII.vue";
  export default {
    name: 'ProjectProcessForm',
    components: {
      companyName,
    },
    data() {
      // 自定义验证函数
      const validateProductInfo = (rule, value, callback) => {
        const { proLevelOne, proLevelTwo, proModel } = this.projectForm.designList[0];
        if (!proLevelOne && !proLevelTwo && !proModel) {
          callback(new Error('产品大类、产品中类、产品型号至少填写一项'));
        } else {
          callback();
        }
      };
      return {
        activeStep: 0, // 当前激活的步骤
        activePanels: ['X'], // 当前展开的面板
        userList:[],
        // 步骤列表
        stepsList: [
          { name: '项目设计',code: 'X1' },
          { name: '项目立项',code: 'X2' },
          { name: '项目投标',code: 'X3' },
          { name: '中标签约',code: 'X4' }
        ],
        optionsList: [
          { name: '项目设计',code: 'X1' },
          { name: '项目立项',code: 'X2' },
          { name: '项目投标',code: 'X3' },
          { name: '中标签约',code: 'X4' }
        ],
        selectedValues: [],
        // 表单数据
        projectForm: {
          // 基本信息
          projectName: '', // 需求名称
          probjectSorts: '', // 需求分类
          chanceType: '', // 机会分类
          areaCode: '', // 区域
          areaName:'',//区域名称
          customerCode: '', // 用户单位编码
          agentCode: '',//经销商编码
          salesman: '', // 销售人员
          province: '', // 省份
          city: '', // 地市
          deptName: '', // 部门/科室
          chargePerson: '', // 负责人
          phone: '', // 联系电话
          projectLeaderName: '',//小组长
          estimatedAmount: '',
          dueDate:null,//到期日
          customerChannel:'',
          isBid:'',
          isSpecialOffer: '',//是否特价
          specialOfferType: '',//特价类型
          reason: '',
          note: '',
          // 项目设计
          // designDueTime: '',//项目设计到期时间
          // scenesType: '1',//场景
          // proLevelOne: '', // 产品大类
          // proLevelTwo: '', // 产品中类
          // proModel: '', // 产品型号
          // proType: '', // 产品类型
          // lianqun: '', // 链群
          // nosignProcode: '',//非标产品型号
          // 项目立项
          designDueTime: '',//到期时间
          documentaryType: '', // 跟单商类别
          agentName: '', // 经销商名称
          partner: '', // 合伙人名称

          // 项目投标
          bidDueTime: '',//到期时间
          // bidTime: '',//投标时间
          products: [
            {
              id:null,
              proLevelOne: '', // 产品大类
              proLevelTwo: '', // 产品中类
              proModel: '', // 产品型号
              proType: '', // 产品类型
              num: '', // 数量
              price: '', // 投标价格
              lianqun:'',
              isDesign:'',

            }
          ],
          designList: [
            {
              id:null,
              proLevelOne: '', // 产品大类
              proLevelTwo: '', // 产品中类
              proModel: '', // 产品型号
              proType: '', // 产品类型
              num: '', // 数量
              price: '', // 投标价格
              lianqun:'',
              isDesign:'',
              twoList: []
            },
          ],

          // 中标签约
          signDueTime: '',//到期时间
          bidResult: '', // 开标结果
          customerName: '', // 中标用户单位
          expOnlineDate: '', // 预计下单时间
          delReason: '', // 丢标原因
        },
        contentdetailsDialog:false,
        contentdetailsAdd:false,

        formModel:{
          loudContent:[
            {
              mainId:null,
              contentName:null,
              contentCode:null,
              funnelCode:null,
              loudStatusR:null,
              contentMsg:null,//协同信息
              reason:null,//拒绝协同原因
            }
          ],
        },
        rules: {
          contentName: [{ required: true, message: '请选择用户名称', trigger: 'change' }],
          contentMsg: [{ required: true, message: '请输入协同问题', trigger: 'blur' }]
        },
        // 表单验证规则 - 优化为详细提示信息
        formRules: {
          //基本信息
          agentName: [{ required: true, message: '请输入经销商名称', trigger: 'blur' }],
          province: [
            { required: true, message: '请选择省份', trigger: 'blur' }
          ],
          city: [
            { required: true, message: '请选择地市', trigger: 'blur' }
          ],
          customerChannel: [
            { required: true, message: '请选择渠道', trigger: 'blur' }
          ],
          isBid: [
            { required: true, message: '请选择是否投标', trigger:['blur','change'] }
          ],
          isSpecialOffer: [
            { required: false,message: '请选择是否特价', trigger: 'change' }
          ],
          specialOfferType: [
            { required: true, message: '请选择特价类型', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (this.projectForm.isSpecialOffer == 1) { // 若选择“是”
                  if (!value) { // 未选择特价类型
                    return callback(new Error('请选择特价类型'));
                  }
                }
                callback(); // 校验通过
              },
              trigger: 'change'
            }
          ],
          scenesType: [
            { required: true, message: '请选择场景', trigger: ['blur','change']}
          ],
          proLevelOne: [
            { required: true, message: '请选择产品大类', trigger: ['blur','change'] }
          ],
          proLevelTwo: [
            { required: true, message: '请选择产品中类', trigger: ['blur','change'] }
          ],
          proModel: [
            { required: true, message: '请输入产品型号信息', trigger: ['blur','change'] }
          ],
          proType: [
            { required: true, message: '请输入产品类型信息', trigger: 'blur' }
          ],
          nosignProcode: [
            { required: true, message: '请输入非标产品型号信息', trigger: 'blur' }
          ],
          lianqun: [
            { required: true, message: '请选择所属链群信息', trigger: 'blur' }
          ],
          num: [
            { required: true, message: '请输入产品数量，必须为大于0的数字', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                // 处理空值和非数字情况
                if (value === null || value === '' || isNaN(Number(value))) {
                  callback(new Error('请输入有效的数字'));
                }
                // 验证是否大于0
                else if (Number(value) <= 0) {
                  callback(new Error('数量必须为大于0的数字'));
                }
                // 验证是否为整数
                else if (!Number.isInteger(Number(value))) {
                  callback(new Error('数量必须为整数'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ],
          price: [
            { required: true, message: '请输入投标单价，必须为大于0的数字', trigger: ['blur','change']},
            {
              validator: (rule, value, callback) => {
                // 处理空值和非数字情况
                if (value === null || value === '' || isNaN(Number(value))) {
                  callback(new Error('请输入有效的数字'));
                }
                // 验证是否大于0
                else if (Number(value) <= 0) {
                  callback(new Error('投标价格必须为大于0的数字'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ],

          //项目设计
          dueDate: [
            { required: true, message: '请选择到期时间', trigger: 'change' }
          ],
          'designList[0].scenesType': [
            { required: true, message: '请选择场景', trigger: 'blur' }
          ],
          // 'designList[0].proLevelOne': [
          //   { validator: validateProductInfo, trigger: 'blur' }
          // ],
          // 'designList[0].proLevelTwo': [
          //   { validator: validateProductInfo, trigger: 'blur' }
          // ],
          // 'designList[0].proModel': [
          //   { validator: validateProductInfo, trigger: 'blur' }
          // ],
          // 'designList[0].proType': [
          //   { required: true, message: '请输入产品类型信息', trigger: ['blur', 'change'] }
          // ],
          // 'designList[0].nosignProcode': [
          //   { required: true, message: '请输入非标产品型号信息', trigger: 'blur' }
          // ],
          // 'designList[0].lianqun': [
          //   { required: true, message: '请选择所属链群信息', trigger: 'blur' }
          // ],
          //项目立项
          designDueTime: [
            { required: true, message: '请选择到期时间', trigger: 'change' }
          ],
          documentaryType: [
            { required: true, message: '请选择跟单商类别', trigger: 'blur' }
          ],
          partner: [
            { required: true, message: '请输入合伙人名称', trigger: 'blur' }
          ],
          // 项目投标验证规则（动态绑定）
          bidDueTime: [
            { required: true, message: '请选择到期时间', trigger: 'change' }
          ],
          // bidTime: [
          //   { required: true, message: '请选择投标时间', trigger: 'change' }
          // ],
          //中标签约
          signDueTime: [
            { required: true, message: '请选择到期时间', trigger: 'change' }
          ],
          bidResult: [
            { required: true, message: '请选择开标结果', trigger: 'change' }
          ],
          expOnlineDate: [
            { required: true, message: '请选择预计下单时间', trigger: 'change' }
          ],
          delReason: [
            { required: true, message: '请详细说明丢标原因', trigger: 'blur' }
          ],
        },
        // 开标结果选项
        bidResultOptions: [
          { value: '1', label: '中标' },
          { value: '2', label: '丢标' },
          { value: '3', label: '流标' },
          { value: '4', label: '废标' }
        ],
        type: 1,//1为货物类，2为工程类
        lianqunList: [],//链群
        xiangmu: [],//机会分类
        salesmanList: [],//销售人员
        customerNameList: [],//用户单位
        bscLoudDeptPeople: [],//负责人
        proSelect: {
          pcode: 0,
          level: 1,
        },
        provinceList: [],
        province: '',
        shenglist: [],//省份
        cityList: [],//地市
        productByNameList: [],//产品型号
        chanlList: [],//渠道
        agentList: [],//经销商
        proudctLevelArr: [],
        oneList:[],
        twoList:[],
        proModelList:[],
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
          }
        },
        titleDig: false,
        institutionalX:false,
        closeProjectModal: false,
        closeForm:{
          reason: '',
          note: ''
        },
        addUser: {
          id: '',
          deptName: '',
          deptType: '',
          leader: '',
          phone: '',
          email: '',
          status: '',
          countryId: '',
          country: '',
          provinceId: '',
          province: '',
          cityId: '',
          city: '',
          areaId: '',
          landmark:'',
          area: '',
          address: '',
          shengobj: '',
          shiobj: '',
          quobj: '',
          selectId: '',
          subFlag: '',
          deptSourceChannel: '',
          longitude: '',
          latitude: '',
          parentCode: '',
          schoolTypeName:'',
        },
        stVal: null,
        subLoad: false,
        cachedDesignProducts: [],

      };
    },
    methods: {
      validateDesignField(rule, value, callback, index) {
        const design = this.projectForm.designList[index];
        const fieldName = rule.field.split('.')[1]; // 获取当前验证的字段名
        // 检查是否有任意一个字段已填写（三选一逻辑）
        const hasValue = design.proLevelOne || design.proLevelTwo || design.proModel;
        // 如果都没填，提示至少填写一项
        if (!hasValue) {
          return callback(new Error('产品大类、产品中类、产品型号至少填写一项'));
        }
        // 特殊逻辑：如果选择了产品中类但没有选择产品大类
        if (fieldName === 'proLevelTwo' && design.proLevelTwo && !design.proLevelOne) {
          return callback(new Error('请先选择产品大类'));
        }
        // 验证通过
        callback();
      },
      // 验证产品相关字段，确保至少填写一项
      validateProductField(rule, value, callback, index) {
        const product = this.projectForm.products[index];
        // 检查产品大类、中类、型号是否都未填写
        const isEmpty = !product.proLevelOne && !product.proLevelTwo && !product.proModel;

        if (isEmpty) {
          callback(new Error('产品大类、产品中类、产品型号至少填写一项'));
        } else {
          callback();
        }
      },
      // 手动切换面板状态
      togglePanel(panelName) {
        const index = this.activePanels.indexOf(panelName);
        if (index > -1) {
          // 如果已展开则关闭
          this.activePanels.splice(index, 1);
        } else {
          // 如果已关闭则展开
          this.activePanels.push(panelName);
        }
      },
      handleRadioChange(value) {
        // 检查当前值是否已在选中列表中
        const index = this.selectedValues.indexOf(value);

        if (index > -1) {
          // 如果已存在，则移除（取消选择）
          this.selectedValues.splice(index, 1);
        } else {
          // 如果不存在，则添加（选中）
          this.selectedValues.push(value);
        }
      },
      //关闭弹窗,清空数据
      closeDialogUser() {
        this.institutionalX = false
        this.newDialogUser = false
        this.updateDialog = false
        this.insertFlag = false
        this.reFlag = false
        //清空数据
        this.addUser.deptName = '';
        this.addUser.deptType = '';
        this.addUser.phone = '';
        this.addUser.leader = '';
        this.addUser.email = '';
        this.addUser.province = '';
        this.addUser.provinceId = '';
        this.addUser.city = '';
        this.addUser.cityId = '';
        this.addUser.area = '';
        this.addUser.areaId = '';
        this.addUser.landmark ='';
        this.addUser.address = '';
        this.addUser.parentCode = '';
        this.addUser.deptSourceChannel = '';
        this.stVal = null;
        this.addUser.schoolTypeName = '';
      },
      //关闭弹窗---关闭项目
      handleCloseProject(){
        this.closeProjectModal = false;
      },
      submitProjectModal(){
          //在这里做关闭
          this.projectForm.reason = this.closeForm.reason;
          this.projectForm.note = this.closeForm.note;
          ss.loud.closeStep(this.projectForm).then(rd => {
            this.subLoad = false
            if(rd.f == true){
              this.$message.success('已关闭')
            }
          })
        this.closeProjectModal = false;
      },
      closeCompanyName(propData){
        this.closeDialogUser();
      },
      /**
       * 同步检查当前节点必填项是否已填写（用于禁用状态判断）
       * 注意：这是简化版校验，仅检查是否有值，不校验格式
       */
      async handlePanelChange(newPanels) {
        const originalPanels = [...this.activePanels];
        // 1. 始终保留基本信息面板（X），不允许关闭
        if (!newPanels.includes('X')) {
          newPanels.unshift('X');
        }

        // 2. 非工程类直接放行（保持原有逻辑）
        if (this.projectForm.probjectSorts !== 'xm') {
          this.syncStepWithPanel(newPanels);
          this.activePanels = newPanels;
          return;
        }

        // 3. 工程类：校验所有要打开的面板是否解锁
        const stepPanels = newPanels.filter(panel => panel !== 'X'); // 排除基本信息
        let hasLockedPanel = false;

        // 遍历校验每个步骤面板的解锁状态
        for (const panel of stepPanels) {
          const isUnlocked = await this.isPanelUnlocked(panel);
          if (!isUnlocked) {
            hasLockedPanel = true;
            break;
          }
        }

        // 3.1 存在未解锁面板：提示并恢复原状态
        if (hasLockedPanel) {
          this.activePanels = originalPanels;
          return;
        }

        // 3.2 所有面板已解锁：同步activeStep并更新面板
        this.syncStepWithPanel(newPanels);
        this.activePanels = newPanels;
      },
      async isPanelUnlocked(panelCode) {
        const panelOrder = ['X', 'X1', 'X2', 'X3', 'X4'];
        const panelIndex = panelOrder.indexOf(panelCode);
        if (panelIndex === -1) return false; // 无效面板

        // 当前激活节点对应的面板信息
        const currentStepCode = this.stepsList[this.activeStep].code;
        const currentPanelIndex = panelOrder.indexOf(currentStepCode);

        // 规则1：已完成节点（在当前节点之前）→ 解锁
        if (panelIndex < currentPanelIndex) {
          return true;
        }

        // 规则2：当前节点→解锁
        if (panelIndex === currentPanelIndex) {
          return true;
        }

        // 规则3：下一节点（当前+1）→ 需验证当前节点是否填完
        if (panelIndex === currentPanelIndex + 1) {
          return await this.validateCurrentPanel();
        }

        // 规则4：下下节点及以后→锁定
        return false;
      },

      /**
       * 辅助方法：校验当前节点所有必填项是否完整- 校验是否通过
       */
      async validateCurrentPanel() {
        // 获取当前节点的必填字段
        const currentPanelCode = this.stepsList[this.activeStep].code;
        const fieldsToValidate = this.getFieldsToValidateForPanel(currentPanelCode);
        if (fieldsToValidate.length === 0) return true; // 无必填项则默认通过

        // 执行异步校验
        const allErrors = await this.validateFieldPromise(fieldsToValidate);
        const hasErrors = Object.values(allErrors).some(error => error); // 是否有校验错误
        const allFilled = this.checkEmptyFields(fieldsToValidate); // 是否所有字段有值

        return !hasErrors && allFilled;
      },

      /**
       * 辅助方法：根据面板状态同步activeStep（非工程类和工程类已解锁场景通用）
       * @param {Array} newPanels - 新面板列表
       */
      syncStepWithPanel(newPanels) {
        const stepPanels = newPanels.filter(panel => panel !== 'X');
        if (stepPanels.length === 0) return;

        // 获取最新打开的面板（可能是当前/已完成节点）
        const latestPanel = stepPanels[stepPanels.length - 1];
        const targetStepIndex = this.stepsList.findIndex(step => step.code === latestPanel);

        // 仅当目标节点是当前或已完成节点时，更新activeStep
        if (targetStepIndex !== -1 && targetStepIndex <= this.activeStep + 1) {
          this.activeStep = targetStepIndex;
        }
      },
      // 处理跟单商类型变化
      handleDocumentaryTypeChange(value) {
        console.log(value)
        // 重置相关字段
        if(value){
          this.$set(this.projectForm,'documentaryType',value.code)
          // if (value.code != '1') this.projectForm.agentName = '';
          // if (value.code != '2') this.projectForm.partner = '';
        }else{
          this.$set(this.projectForm,'documentaryType','')
        }
        this.$forceUpdate()
      },
      //选择经销商
      showComList(val){
        if(val){
          ss.netApi.selectByUserNameLoud(val).then(res => {
            if(res.obj.length == 0){
              this.lianqunList = this.$store.getters.dicts["xsyb_lianqun"];
              this.chanlList = this.$store.getters.dicts["sales_region"];
            }
            this.agentList = res.obj
            this.projectForm.agentCode = res.obj[0].usercode
            //获取渠道链群
            if (res.obj && res.obj.length > 0 && res.obj[0] && res.obj[0].lianquns && res.obj[0].lianquns.length > 0){
              this.lianqunList = res.obj[0].lianquns;
            }
            if (res.obj && res.obj.length > 0 && res.obj[0].qudaos && res.obj[0].qudaos.length > 0) {
              this.chanlList = res.obj[0].qudaos;
            }
            if(res.obj&&res.obj.length == 1){
              let proSelect = {
                pcode: 0,
                level: 1,
                usercode: res.obj[0].usercode,
              }
              ss.Dictservice.arealistLoud(proSelect).then(rd => {
                this.shenglist = rd;
                // this.projectForm.province = ''
                // this.projectForm.city = ''
                // this.province = '';
                // this.city = '';
              })
            }
          })
        }
      },
      //项目设计添加产品
      addDesign(){
        const newProduct = {
          proLevelOne: '', // 产品大类
          proLevelTwo: '', // 产品中类
          proModel: '', // 产品型号
          proType: '', // 产品类型
          num: '', // 数量
          price: '', // 投标价格
          lianqun:'',
        };
        this.projectForm.designList.push(newProduct);
        // 强制更新DOM
        this.$forceUpdate();
      },
      //项目设计删除产品
      deleteDesign(index) {
        this.projectForm.designList.splice(index, 1);
      },

      // 添加产品--项目立项
      addProduct() {
        const newProduct = {
          proLevelOne: '',
          proLevelTwo: '',
          proModel: '',
          proType: '',
          num: '',
          price: '',
          totalPrice: ''
        };
        this.projectForm.products.push(newProduct);
        // 强制更新DOM
        this.$forceUpdate();
      },
      // 删除产品--项目立项
      deleteProduct(index) {
        this.projectForm.products.splice(index, 1);
      },
      // 重置表单
      resetForm() {
        this.$router.push({path: "/loudnew/LoudMain"});
      },
      //获取链群
      getChainGroupList(){
        ss.Dictservice.listbycategory("xsyb_lianqun").then(rd=>{
          this.lianqunList = rd;
        })
      },
      deepCopy(p, c) {
        var c = c || {};
        for (var i in p) {
          if (typeof p[i] === 'object') {
            c[i] = (p[i].constructor === Array) ? [] : {};
            this.deepCopy(p[i], c[i]);
          } else {
            c[i] = p[i];
          }
        }
        return c;
      },
      showProduct(promodel, index, eventType){
        if (index === undefined) return;
        var data = {
          promodel : promodel,
          oneLid:this.projectForm.designList[index].proLevelOne,
          procategory:this.projectForm.designList[index].proLevelTwo,
        }
        console.log(data)
        ss.ProductLevel.selectModelByLevel(data).then(rd => {
          this.proModelList = rd.obj;
          if(rd.obj&&rd.obj.length == 1){
            this.$set(this.projectForm.designList[index],'proLevelOne',rd.obj[0].prodseries)
            this.$set(this.projectForm.designList[index],'proModel',rd.obj[0].promodel)
            this.$set(this.projectForm.designList[index],'proLevelTwo',rd.obj[0].procategory)
            this.$set(this.projectForm.designList[index],'lianqun',rd.obj[0].lianqun)
            this.$set(this.projectForm.designList[index],'proType',rd.obj[0].protype)
            //
            // this.projectForm.designList[0].proLevelOne = rd.obj[0].prodseries;
            // this.projectForm.designList[0].proModel = rd.obj[0].promodel;
            // this.projectForm.designList[0].proLevelTwo = rd.obj[0].procategory;
            // this.projectForm.designList[0].lianqun = rd.obj[0].lianqun;
            // this.projectForm.designList[0].proType = rd.obj[0].protype;
          }
        });
      },
      //根据区域带出销售人员
      matchsalesman(province){
        if(null != province && '' != province){
          this.projectForm.areaName = province.des;
        }
        var query = {
          city:this.projectForm.areaName,
          distribution:this.projectForm.customerChannel
        }
        ss.UserService.getNewLoudUserNamesByarea(query).then(names => {
          this.salesmanList = names.obj;
          var user = {
            id:this._user.usercode,
            userName:this._user.username
          }
          this.salesmanList.push(user);
        })
      },
      // 省份选择器
      handleItemChange4(o, salesman, city) {
        this.projectForm.city = city;
        if (city == null) {
          this.projectForm.city = null;
        }
        this.provinceList = _.find(this.shenglist, {code: o});
        this.projectForm.province = this.provinceList.name;
        if(o){
          ss.Dictservice.areaTreelistLoud({code: o}).then(rd => {
            this.cityList = rd.zlist;
          })
        }
        if(this.projectForm.agentName != null){
          //控制渠道
          let qudao = {
            usercode:this.projectForm.agentCode,
            areaCode:this.projectForm.province,
          }
          ss.OrderMainService.getChannelByAreaLoud(qudao).then(rd => {
            this.chanlList = rd.msg;
          })
        }
      },
      handleItemChange2(o) {
        this.projectForm.city = o;
        this.city = o;
      },
      //获取用户单位
      showGroupList(value) {
        ss.MuBiao.getUserLoud(value).then(res => {
          this.customerNameList = res
          this.projectForm.customerCode = res[0].id || ''
        })
        if (value != '' && value != null){
          ss.MuBiao.customerCarryPerson(value).then(res => {
            this.bscLoudDeptPeople = res.msg;
          })
        }else {
          this.bscLoudDeptPeople = [];
        }
      },
      //新增收货单位
      createAddress() {
        this.titleDig = "新建用户单位"
        this.institutionalX = true
      },
      //根据负责人获取联系电话
      showCarryPerson(){
        let chargePerson = this.projectForm.chargePerson;
        if (chargePerson != null){
          let person = this.bscLoudDeptPeople.find(a=>a.contactPerson == chargePerson)
          this.projectForm.phone = person?person.phone : '';
        }
      },
      //获取省份
      loadAreas(i) {
        ss.Dictservice.arealistLoud(this.proSelect).then(rd => {
          this.shenglist = rd;
        })
      },
      //点击省份
      handleItemChange1(o, salesman, city){
        this.projectForm.city = city;
        if (city == null) {
          this.projectForm.city = null;
        }
        this.provinceList = _.find(this.shenglist, {code: o});
        this.projectForm.province = this.provinceList.name;
        if(o){
          ss.Dictservice.areaTreelistLoud({code: o}).then(rd => {
            this.cityList = rd.zlist;
          })
        }
        if(this.projectForm.agentName != null){
          //控制渠道
          let qudao = {
            usercode:this.projectForm.agentCode,
            areaCode:this.projectForm.province,
          }
          ss.OrderMainService.getChannelByAreaLoud(qudao).then(rd => {
            this.chanlList = rd.msg;
            this.projectForm.customerChannel = '';
          })
        }

      },
      changeType(val){
        if(val){
          this.$set(this.projectForm.designList[0],'scenesType',val.code)
        }else{
          this.$set(this.projectForm.designList[0],'scenesType','')
        }
        if(val){
          this.$set(this.projectForm,'scenesType',val.code)

        }else{
          this.$set(this.projectForm,'scenesType','')
        }
        this.$forceUpdate();
      },
      //点击场景
      changeScenesType(val){
        if(val){
          this.$set(this.projectForm,'scenesType',val.code)

        }else{
          this.$set(this.projectForm,'scenesType','')
        }
        console.log(this.projectForm.scenesType);
        //进行强制数据渲染
        this.$forceUpdate();
      },
      changeNum(value, index) {
        if(null != value.price && '' != value.price){
          value.totalPrice = value.price * value.num;
        }
        //进行强制数据渲染
        this.$forceUpdate();
      },
      //点击产品型号
      changeProducts(value, index) {
        console.log(value)
        this.$set(this.projectForm.products[index],"price" , value.price);
        this.$set(this.projectForm.products[index],"proModel" , value.proModel);
        this.$set(this.projectForm.products[index],"proCode" , value.proCode);
        this.$set(this.projectForm.products[index],"proLevelOne" , value.cpdlname);
        this.$set(this.projectForm.products[index],"proLevelCode" , value.cpdlcode);
        this.$set(this.projectForm.products[index],"proType" , value.protype);
        this.$set(this.projectForm.products[index],"proLevelTwo" , value.procategory);
        this.$set(this.projectForm.products[index],"lianqun" , value.lianqun);
        this.$set(this.projectForm.products[index],"totalPrice" , value.price * this.projectForm.products[index].num);
      },
      salesmanChange(o) {
        this.salesman = o
        this.projectForm.salesman = o;
        //进行强制数据渲染
        this.$forceUpdate();
      },
      //确认提交
      validateForm() {
        this.$refs.projectForm.validate(valid => {
          console.log(valid)
        })



        // 所有验证通过
        // this.$message.success('验证通过，正在提交...');
        // this.subLoad = true
        // 提交表单数据
        // ss.loud.newSaveAndUpdateResource(this.projectForm).then(rd => {
        //   this.subLoad = false
        //   this.$router.push({path: "/loudnew/LoudMain"});
        // }).catch(err => {
        //   this.$message.error('提交失败: ' + (err.message || '未知错误'));
        // });
      },
      getById(id){
        ss.loudnew.getLoudByIdXs(id).then(rd => {
          // 缓存designList中的产品信息（用于后续“是否投标为否”时复用）
          this.cachedDesignProducts = rd.obj.designList.map(design => ({
            proLevelOne: design.proLevelOne || '',
            proLevelTwo: design.proLevelTwo || '',
            proModel: design.proModel || '',
            proType: design.proType || '',
            num: design.num || '',
            price: design.price || '',
            lianqun: design.lianqun || '',
            nosignProcode: design.nosignProcode || '' // 非标产品型号
          }));
          //如果存在销售经销商
          if(rd.obj.documentaryType == '1'){
            //获取渠道链群
            if(rd.obj.lianquns&&rd.obj.lianquns.length>0){
              this.lianqunList = rd.obj.lianquns;
            }
            if(rd.obj.qudaos&&rd.obj.qudaos.length>0){
              this.chanlList = rd.obj.qudaos;
            }
          }else {
            this.chanlList = this.$store.getters.dicts["sales_region"];
          }
          //判断节点
          if((rd.obj.statusR == 'R5' || rd.obj.statusR == 'R6') && !this.$store.getters.hasRole('swyl_admin,swyl_wanglgly')){
            this.disabled = true;
          }else {
            this.disabled = false;
          }
          this.activeStep = this.stepsList.findIndex(item => item.code === rd.obj.statusR);
          this.activePanels.push(rd.obj.statusR)
          this.upmatchsalesman(rd.obj.areaName,rd.obj.customerChannel)
          this.projectForm = rd.obj;

          if(null != rd.obj.selectedValues && '' != rd.obj.selectedValues){
            this.selectedValues = rd.obj.selectedValues.split(",");
          }
          this.projectForm.isBid =  rd.obj.isBid? rd.obj.isBid.toString() : '';
          if( rd.obj.products != null &&  rd.obj.products.length > 0){
            this.projectForm.products = rd.obj.products;
            this.projectForm.products.forEach(item=>{
              item.totalPrice = item.num * item.price
              item.scenesType = this.projectForm.scenesType;
            })
          }else {
            // 重置产品列表，保留一个空项
            this.projectForm.products = [
              {
                proLevelOne: '',
                proLevelTwo: '',
                proModel: '',
                proType: '',
                num: '',
                price: ''
              }
            ];
          }
          if(rd.obj.designList.length>0){
            this.projectForm.designList = rd.obj.designList;
            this.projectForm.designList[0].scenesType = this.projectForm.scenesType;
            this.projectForm.designList.forEach((item,index)=>{
              if(item.proLevelOne!=null){
                this.selectTwo(item.proLevelOne,index,'detail');
              }
            })
            // if(this.projectForm.designList[0].proLevelOne != null){
            //   this.selectTwo(this.projectForm.designList[0].proLevelOne,'0');
            // }
          }else{
            this.projectForm.designList = [
              {
                id:null,
                proLevelOne: '', // 产品大类
                proLevelTwo: '', // 产品中类
                proModel: '', // 产品型号
                proType: '', // 产品类型
                num: '', // 数量
                price: '', // 投标价格
                lianqun:'',
                isDesign:'',
              },
            ]
          }
          // this.projectForm.productsitem = this.add.products;
          this.showChanceType(rd.obj, id);

          if(null != this.projectForm.agentCode && '' != this.projectForm.agentCode
                  && null != this.projectForm.province && '' != this.projectForm.province
          ){
            //控制渠道
            let qudao = {
              usercode:this.projectForm.agentCode,
              areaCode:this.projectForm.province,
            }
            ss.OrderMainService.getChannelByAreaLoud(qudao).then(rd => {
              this.chanlList = rd.msg;
            })
          }
          if(null != this.projectForm.agentCode && '' != this.projectForm.agentCode
                  && null != this.projectForm.documentaryType && '' != this.projectForm.documentaryType
                  && null != this.projectForm.customerChannel && '' != this.projectForm.customerChannel
                  && null != this.projectForm.province && '' != this.projectForm.province

          ){
            this.getProduct();
          }
          for (var i =0 ;i< this.shenglist.length; i++){
            if(this.shenglist[i].name == this.projectForm.province){
              console.log("shenglist",this.shenglist[i])
              this.handleItemChange4(this.shenglist[i].code,this.projectForm.salesman,this.projectForm.city);
              break;
            }
          }
          //销售人员默认当前登录人
          if (this._user.usertype == '0') {
            console.log(this._user.username,"username");
            this.projectForm.salesman = this._user.username
          }
        })
      },
      upmatchsalesman(area,customerChannel){
        var query = {
          city:area,
          distribution:customerChannel
        }
        ss.UserService.getNewLoudUserNamesByarea(query).then(names => {
          this.salesmanList = names.obj;
          var user = {
            id:this._user.usercode,
            userName:this._user.username
          }
          this.salesmanList.push(user);
        })

      },
      loadAreaUpdate(o, salesman, city ,agentCode) {
        let proSelect = {
          pcode: 0,
          level: 1,
        }
        if(agentCode == null || agentCode == ''){
          ss.Dictservice.arealist(proSelect).then(rd => {
            this.add.shenglist = rd;
          })
        }else {
          let proSelect = {
            pcode: 0,
            level: 1,
            usercode: agentCode,
          }
          ss.Dictservice.arealistLoud(proSelect).then(rd => {
            this.add.shenglist = rd;
          })
        }
        this.handleItemChange4(o, salesman, city);
      },
      //项目分类
      showChanceType(values, id) {
        this.xiangmu = null;
        let chanceTypes = this.$store.getters.dictlist("chance_type_loud");
        let newChanceTypes;
        this.xiangmu = this.deepCopy(chanceTypes, newChanceTypes);
        let json = this.xiangmu;
        var infos = [];
        for (let i in json ){
          infos.push(json [i])
        }
        this.xiangmu = infos;
        var result = false;
        if (values != null) {
          for (let i = 0; i < chanceTypes.length; i++) {
            if (chanceTypes[i].code == values.chanceType) {
              result = true;
              break;
            }
          }
          if (result == false) {
            console.log(values)
            let newXiangmu =
                    {
                      "category": "chance_type_loud",
                      "code": values.chanceType,
                      "des": values.chanceTypeName,
                      "id": "",
                      "name": values.chanceTypeName,
                      "pid": "",
                      "refid": "",
                    }
            this.xiangmu.push(newXiangmu);
          }
        }

        if (id == null) {
          this.projectForm.chanceType = '';
        }
      },
      // 获取需要验证的字段

      getFieldsToValidate(panel) {
        const fields = [];
        // 缓存designList的第一个元素的scenesType，供全局使用
        const firstSceneType = this.projectForm.designList[0].scenesType;

        // 根据面板添加需要验证的字段
        switch (panel) {
          case 'isBid0':
            // 是否投标为否的时候需要校验的字段
            // 遍历产品列表，根据显示条件收集验证字段
            this.projectForm.products.forEach((product, index) => {
              fields.push(
                  `products[${index}].proLevelOne`,
                  `products[${index}].proLevelTwo`,
                  `products[${index}].proModel`,
                  `products[${index}].proType`,
                  `products[${index}].num`,
                  `products[${index}].price`
              );
            });
            break;
          case 'X1':
            // 项目设计
            // 循环遍历整个designList数组
            if (this.projectForm.probjectSorts === 'xm') {
              fields.push(`designList[0].scenesType`);
            }
            this.projectForm.designList.forEach((design, index) => {
              // 为每个design元素添加lianqun字段验证
              fields.push(`designList[${index}].lianqun`);
              // 工程类需验证场景
              // 货物类或工程类标准场景需验证的字段
              // 使用第一个元素的scenesType进行判断
              if (firstSceneType != 2) {
                fields.push(
                    `designList[${index}].proLevelOne`,
                    `designList[${index}].proLevelTwo`,
                    `designList[${index}].proModel`,
                    `designList[${index}].proType`
                );
              }
              // 工程类非标场景需验证的字段
              // 使用第一个元素的scenesType进行判断
              if (firstSceneType == 2) {
                fields.push(`designList[${index}].nosignProcode`);
              }
            });
            // 添加dueDate字段验证
            fields.push('dueDate');
            break;
          case 'X2': // 项目立项
            if(this.selectedValues.includes('X2') && !this.selectedValues.includes('X1')){
              // 循环遍历整个designList数组
              if (this.projectForm.probjectSorts === 'xm') {
                fields.push(`designList[0].scenesType`);
              }
              this.projectForm.designList.forEach((design, index) => {
                // 为每个design元素添加lianqun字段验证
                fields.push(`designList[${index}].lianqun`);
                // 工程类需验证场景
                // 货物类或工程类标准场景需验证的字段
                // 使用第一个元素的scenesType进行判断
                if (firstSceneType != 2) {
                  fields.push(
                      `designList[${index}].proLevelOne`,
                      `designList[${index}].proLevelTwo`,
                      `designList[${index}].proModel`,
                      `designList[${index}].proType`
                  );
                }
                // 工程类非标场景需验证的字段
                // 使用第一个元素的scenesType进行判断
                if (firstSceneType == 2) {
                  fields.push(`designList[${index}].nosignProcode`);
                }
              });
            }
            fields.push('designDueTime', 'documentaryType');
            if (this.projectForm.documentaryType == 1) {
              fields.push('agentName');
            }
            if (this.projectForm.documentaryType == 2) {
              fields.push('partner');
            }
            break;
          case 'X3':
            // 项目投标
            fields.push('bidDueTime');

            // 情况1: 包含X3，不包含X1和X2
            if(this.selectedValues.includes('X3') &&
                !this.selectedValues.includes('X1') &&
                !this.selectedValues.includes('X2')){
              // 循环遍历整个designList数组
              this.projectForm.designList.forEach((_, index) => {
                fields.push(`designList[${index}].lianqun`);

                if (this.projectForm.probjectSorts === 'xm') {
                  fields.push('designList[0].scenesType');
                }

                // 使用第一个元素的scenesType进行判断
                if (this.projectForm.probjectSorts === 'sd' ||
                    (this.projectForm.probjectSorts === 'xm' && firstSceneType == 1)) {
                  fields.push(
                      `designList[${index}].proLevelOne`,
                      `designList[${index}].proLevelTwo`,
                      `designList[${index}].proModel`,
                      `designList[${index}].proType`
                  );
                }

                // 使用第一个元素的scenesType进行判断
                if (firstSceneType == 2) {
                  fields.push(`designList[${index}].nosignProcode`);
                }
              });

              fields.push('documentaryType');
              if (this.projectForm.documentaryType == 1) {
                fields.push('agentName');
              }
              if (this.projectForm.documentaryType == 2) {
                fields.push('partner');
              }
            }

            // 情况2: 包含X3和X1，不包含X2
            if(this.selectedValues.includes('X3') &&
                this.selectedValues.includes('X1') &&
                !this.selectedValues.includes('X2')){
              // 循环遍历整个designList数组
              this.projectForm.designList.forEach((_, index) => {
                fields.push(`designList[${index}].lianqun`);

                if (this.projectForm.probjectSorts === 'xm') {
                  fields.push('designList[0].scenesType');
                }

                // 使用第一个元素的scenesType进行判断
                if (this.projectForm.probjectSorts === 'sd' ||
                    (this.projectForm.probjectSorts === 'xm' && firstSceneType == 1)) {
                  fields.push(
                      `designList[${index}].proLevelOne`,
                      `designList[${index}].proLevelTwo`,
                      `designList[${index}].proModel`,
                      `designList[${index}].proType`
                  );
                }

                // 使用第一个元素的scenesType进行判断
                if (firstSceneType == 2) {
                  fields.push(`designList[${index}].nosignProcode`);
                }
              });
            }

            // 1. 工程类(type=2)需要验证场景
            if (this.projectForm.probjectSorts === 'xm') {
              fields.push(`scenesType`);
            }

            // 遍历产品列表
            this.projectForm.products.forEach((product, index) => {
              // 2. 非非标场景(不是2)需要验证产品大类、中类等
              // 使用第一个元素的scenesType进行判断
              const isNonCustomScene = firstSceneType != '2';
              if (isNonCustomScene) {
                fields.push(
                    `products[${index}].proLevelOne`,
                    `products[${index}].proLevelTwo`,
                    `products[${index}].proModel`,
                    `products[${index}].proType`
                );
              }

              // 3. 非标场景(是2)且工程类(type=2)需要验证非标产品型号
              // 使用第一个元素的scenesType进行判断
              const isCustomSceneAndType2 = firstSceneType == '2' && this.projectForm.probjectSorts === 'xm';
              if (isCustomSceneAndType2) {
                fields.push(`products[${index}].nosignProcode`);
              }

              // 4. 所有产品都需要验证数量和投标价格
              fields.push(
                  `products[${index}].num`,
                  `products[${index}].price`,
              );
            });
            break;
          case 'X4':
            // 情况1: 只包含X4
            if(this.selectedValues.includes('X4') &&
                !this.selectedValues.includes('X3') &&
                !this.selectedValues.includes('X2') &&
                !this.selectedValues.includes('X1')){
              // 循环遍历整个designList数组
              this.projectForm.designList.forEach((_, index) => {
                fields.push(`designList[${index}].lianqun`);

                if (this.projectForm.probjectSorts === 'xm') {
                  fields.push('designList[0].scenesType');
                }

                // 使用第一个元素的scenesType进行判断
                if (this.projectForm.probjectSorts === 'sd' ||
                    (this.projectForm.probjectSorts === 'xm' && firstSceneType == 1)) {
                  fields.push(
                      `designList[${index}].proLevelOne`,
                      `designList[${index}].proLevelTwo`,
                      `designList[${index}].proModel`,
                      `designList[${index}].proType`
                  );
                }

                // 使用第一个元素的scenesType进行判断
                if (firstSceneType == 2) {
                  fields.push(`designList[${index}].nosignProcode`);
                }
              });

              fields.push('documentaryType');
              if (this.projectForm.documentaryType == 1) {
                fields.push('agentName');
              }
              if (this.projectForm.documentaryType == 2) {
                fields.push('partner');
              }

              // 1. 工程类(type=2)需要验证场景
              if (this.projectForm.probjectSorts === 'xm') {
                fields.push(`scenesType`);
              }

              // 遍历产品列表
              this.projectForm.products.forEach((product, index) => {
                // 使用第一个元素的scenesType进行判断
                const isNonCustomScene = firstSceneType != '2';
                if (isNonCustomScene) {
                  fields.push(
                      `products[${index}].proLevelOne`,
                      `products[${index}].proLevelTwo`,
                      `products[${index}].proModel`,
                      `products[${index}].proType`
                  );
                }

                // 使用第一个元素的scenesType进行判断
                const isCustomSceneAndType2 = firstSceneType == '2' && this.projectForm.probjectSorts === 'xm';
                if (isCustomSceneAndType2) {
                  fields.push(`products[${index}].nosignProcode`);
                }

                fields.push(
                    `products[${index}].num`,
                    `products[${index}].price`,
                );
              });
            }

            // 情况2: 包含X4和X1，不包含X3和X2
            if(this.selectedValues.includes('X4') &&
                !this.selectedValues.includes('X3') &&
                !this.selectedValues.includes('X2') &&
                this.selectedValues.includes('X1')){
              fields.push('documentaryType');
              if (this.projectForm.documentaryType == 1) {
                fields.push('agentName');
              }
              if (this.projectForm.documentaryType == 2) {
                fields.push('partner');
              }

              if (this.projectForm.probjectSorts === 'xm') {
                fields.push(`scenesType`);
              }

              // 遍历产品列表
              this.projectForm.products.forEach((product, index) => {
                // 使用第一个元素的scenesType进行判断
                const isNonCustomScene = firstSceneType != '2';
                if (isNonCustomScene) {
                  fields.push(
                      `products[${index}].proLevelOne`,
                      `products[${index}].proLevelTwo`,
                      `products[${index}].proModel`,
                      `products[${index}].proType`
                  );
                }

                // 使用第一个元素的scenesType进行判断
                const isCustomSceneAndType2 = firstSceneType == '2' && this.projectForm.probjectSorts === 'xm';
                if (isCustomSceneAndType2) {
                  fields.push(`products[${index}].nosignProcode`);
                }

                fields.push(
                    `products[${index}].num`,
                    `products[${index}].price`,
                );
              });
            }

            fields.push('signDueTime', 'bidResult');
            if (this.projectForm.bidResult == 1) {
              fields.push('expOnlineDate');
            }
            if (this.projectForm.bidResult == 2) {
              fields.push('delReason');
            }
        }
        return fields;
      },
      // 检查数组中指定的字段是否有空值
      checkEmptyFields(arr) {
        // 遍历需要检查的字段数组
        const emptyFields = arr.filter(field => {
          // 处理嵌套字段（如products[0].num）
          const value = this.getNestedValue(this.projectForm, field);
          // 判断是否为空（考虑空字符串、null、undefined）
          return value === '' || value === null || value === undefined;
        });

        if (emptyFields.length > 0) {
          // 存在空字段
          console.log('以下字段为空：', emptyFields);
          return false; // 存在空值
        } else {
          // 所有字段都不为空
          console.log('所有字段均已填写');
          return true; // 无空值
        }
      },

      // 辅助方法：获取嵌套对象属性值（处理products[0].quantity这种格式）
      getNestedValue(obj, path) {
        return path.split('.').reduce((current, key) => {
          // 处理数组格式（如products[0]）
          const arrayMatch = key.match(/^(\w+)\[(\d+)\]$/);
          if (arrayMatch) {
            const [, arrKey, index] = arrayMatch;
            return current && current[arrKey] ? current[arrKey][index] : undefined;
          }
          return current && current[key] !== undefined ? current[key] : undefined;
        }, obj);
      },
      changeValue(val){
        console.log(val,this.selectedValues)

        console.log('projectForm.isSelect的值:', this.projectForm.isSelect)
      },
      //点击申请
      handleApply(){
        //点击申请的时候判断，当前漏斗编号有没有申请过特价，如果申请过特价走了审批流的，那么就跳转到查看页面，申请过没走审批流的可以修改，没申请过到申请页面
         console.log('申请特价',this.projectForm.specialOfferType)
        console.log(this.projectForm.funnelCode)

        if(this.projectForm.specialOfferType!=undefined){
          ss.loudnew.toUrl(this.id,this.projectForm.specialOfferType).then(res=>{
            let url = res.msg + '&funnelId=' + this.id;
            let routeData = this.$router.resolve({ path: url });
            window.open(routeData.href, '_blank');

            // let url = res.msg + '&id=' + this.id
            // this.$router.push({path: url})
          })
          // if(this.projectForm.specialOfferType == 0){
          //   let routeData = this.$router.resolve({path: '/xiangmu/newProject2', query: { protype:3,funnelId: this.id}});
          //   window.open(routeData.href, '_blank');
          // }else{
          //   let routeData = this.$router.resolve({
          //     path: '/newprice2',
          //     query: {
          //       type: this.projectForm.specialOfferType,
          //       funnelId: this.id
          //     }});
          //   window.open(routeData.href, '_blank');
          // }
        }else{
          this.$message.warning('请选择特价类型')
        }
      },
      // 处理是否投标的选择事件
      handleBidChange(value) {
        if(this.projectForm.agentName == null || this.projectForm.agentName == ''){
          this.$message({
            type: 'error',
            message: '请先填写经销商!'
          });
          this.projectForm.isBid = ''
          return;
        }
        if(this.projectForm.province == null || this.projectForm.province == ''){
          this.$message({
            type: 'error',
            message: '请先选择省份!'
          });
          this.projectForm.isBid = ''
          return;
        }
        //如果是江苏和广东
        if(this.projectForm.province == "江苏省" || this.projectForm.province == "广东省"){
          //判断是不是选了地市
          if(this.projectForm.city == null || this.projectForm.city == ''){
            this.$message({
              type: 'error',
              message: '请先选择地市!'
            });
            this.projectForm.isBid = ''
            return;
          }
        }
        if(this.projectForm.customerChannel == null ||  this.projectForm.customerChannel == ''){
          this.$message({
            type: 'error',
            message: '请先选择渠道!'
          });
          this.projectForm.isBid = ''
          return;
        }
        // agentCode、areaCode、currencyCode、customerChannel、scenesType
        var data = {};
        data.scenesType =  this.projectForm.scenesType || '1'    //选择否的情况下没有scenesType，默认显示1
        data.currencyCode = 'CNY'
        data.agentCode = this.projectForm.agentCode
        //区域特殊判断
        if(this.projectForm.city == '苏州市' || this.projectForm.city == '深圳市' || this.projectForm.city == '赤峰市'){
          data.areaCode = this.projectForm.city
        }else {
          data.areaCode = this.projectForm.province
        }
        data.customerChannel = this.projectForm.customerChannel
        ss.OrderMainService.selectPageByLoud(data).then(rd => {
          this.projectForm.productByNameList = rd.msg

          if (this.projectForm.isBid == 0) {
            // 如果缓存有设计阶段的产品信息，则同步到下单区域
            if (this.cachedDesignProducts.length > 0) {
              this.projectForm.products = [...this.cachedDesignProducts];
            } else {
              // 若缓存为空，初始化一个空产品（避免列表为空）
              this.projectForm.products = [{
                proLevelOne: '',
                proLevelTwo: '',
                proModel: '',
                proType: '',
                num: '',
                price: '',
                lianqun: '',
                nosignProcode: ''
              }];
            }
          }
          //进行强制数据渲染
          this.$forceUpdate();
        })
        if(this.projectForm.isBid == 0){
          this.activePanels = ['X','X3']
        }
      },
      // 验证是否满足投标选择的前置条件
      getProduct(){
        var value = this.projectForm.documentaryType;
        if(this.projectForm.agentName == null || this.projectForm.agentName == ''){
          this.$message({
            type: 'error',
            message: '请先填写经销商!'
          });
          return;
        }
        // if(this.projectForm.documentaryType == null || this.projectForm.documentaryType == ''){
        //   this.$message({
        //     type: 'error',
        //     message: '请先填写项目立项!'
        //   });
        //   return;
        // }
        //如果是标准产品
        if(this.projectForm.province == null || this.projectForm.province == ''){
          this.$message({
            type: 'error',
            message: '请先选择销售区域和渠道!'
          });
          this.projectForm.scenesType = '';
          return;
        }
        //如果是标准产品
        if(this.projectForm.customerChannel == null ||  this.projectForm.customerChannel == ''){
          this.$message({
            type: 'error',
            message: '请先选择销售区域和渠道!'
          });
          this.projectForm.scenesType = '';
          return;
        }
        //如果是江苏和广东
        if(this.projectForm.province == "江苏省" || this.projectForm.province == "广东省"){
          //判断是不是选了地市
          if(this.projectForm.city == null || this.projectForm.city == ''){
            this.$message({
              type: 'error',
              message: '请先选择地市!'
            });
            return;
          }
        }
        //如果是代理商
        if(this.$store.getters.hasRole('swyl_gndailishang') == true){
          //如果渠道不为空,场景不为空
          console.log("代理商");
          var data = {};
          data.scenesType =  this.projectForm.scenesType
          data.currencyCode = 'CNY'
          //区域特殊判断
          if(this.projectForm.city == '苏州市' || this.projectForm.city == '深圳市' || this.projectForm.city == '赤峰市'){
            data.areaCode = this.projectForm.city
          }else {
            data.areaCode = this.projectForm.province
          }
          data.customerChannel = this.projectForm.customerChannel
          ss.OrderMainService.selectPageByLoud(data).then(rd => {
            this.projectForm.productByNameList = rd.msg
            //进行强制数据渲染
            this.$forceUpdate();
          })
        }else if(this.projectForm.documentaryType == 1){
          console.log("选择经销商");
          var data = {};
          data.scenesType =  this.projectForm.scenesType
          data.currencyCode = 'CNY'
          data.agentCode = this.projectForm.agentCode
          //区域特殊判断
          if(this.projectForm.city == '苏州市' || this.projectForm.city == '深圳市' || this.projectForm.city == '赤峰市'){
            data.areaCode = this.projectForm.city
          }else {
            data.areaCode = this.projectForm.province
          }
          data.customerChannel = this.projectForm.customerChannel
          ss.OrderMainService.selectPageByLoud(data).then(rd => {
            console.log("rdrdrdrdrd",rd);
            this.projectForm.productByNameList = rd.msg
            //进行强制数据渲染
            this.$forceUpdate();
          })
        }else if((this.projectForm.documentaryType == 2 || this.projectForm.documentaryType == 3) && this.$store.getters.hasRole('swyl_gndailishang')){
          var data = {};
          data.customerChannel =  this.projectForm.customerChannel
          data.scenesType =  this.projectForm.scenesType
          data.currencyCode = 'CNY'
          data.agentCode = this.projectForm.agentCode
          //区域特殊判断
          if(this.projectForm.city == '苏州市' || this.projectForm.city == '深圳市' || this.projectForm.city == '赤峰市'){
            data.areaCode = this.projectForm.city
          }else {
            data.areaCode = this.projectForm.province
          }
          data.customerChannel = this.projectForm.customerChannel
          ss.OrderMainService.selectPageByLoud(data).then(rd => {
            console.log("rdrdrdrdrd",rd);
            this.projectForm.productByNameList = rd.msg
            //进行强制数据渲染
            this.$forceUpdate();
          })
        }
        // 返回验证结果
      },

      changexmlx(){
        console.log("项目立项")
        if(this.projectForm.agentName != null && this.projectForm.agentName != ''){
          this.$set(this.projectForm,'documentaryType',1)
        }
      },
      changeChannelLoud(){
        this.projectForm.scenesType = '';
        this.projectForm.products = [{
          lianqun: '',
          price: '',
          proModel: '', //产品型号
          nosignProcode:'', //非标产品型号
          proCode: '',
          num: null,
          productByNameList:[],
        }];

        this.matchsalesman();
      },

      //查询一级分类
      selectOne() {
        ss.ProService.product1Select().then(rd => {
          this.oneList = rd;
          if(this.projectForm.designList.length>0){
            this.projectForm.designList.forEach((item,index)=>{
              if(item.proLevelOne!=null&&item.proLevelOne!=''){
                this.selectTwo(item.proLevelOne,index)
              }
            })
          }
          // if(this.projectForm.designList[0].proLevelOne != null &&  this.projectForm.designList[0].proLevelOne != ''){
          //   this.selectTwo(this.projectForm.designList[0].proLevelOne);
          // }
        })
      },

      selectTwo(proLevelOne,index,type) {
        const currentDesign = this.projectForm.designList[index];
        if(!type){
          currentDesign.proLevelTwo = '';
          currentDesign.proModel = '';
        }
        if (!proLevelOne) {
          currentDesign.twoList = [];
          return;
        }
        let one = _.find(this.oneList,{levelname:proLevelOne});
        if(one != null && one != ''){
          //查询二级分类
          ss.ProductLevel.selectTwo(one.id).then(rd => {
            // this.twoList = rd;
            currentDesign.twoList = rd;
            this.$forceUpdate()
          });
        }

        // if(proLevelOne){
        //   //筛选id
        //   let one = _.find(this.oneList,{levelname:proLevelOne});
        //   console.log('ASDASD',one);
        //   if(one != null && one != ''){
        //     //查询二级分类
        //     ss.ProductLevel.selectTwo(one.id).then(rd => {
        //       this.twoList = rd;
        //     });
        //   }
        // }else{
        //   this.twoList = []
        // }

      },

      //根据型号查询大类
      selectLevelByModel(promodel) {
        //查询二级分类
        ss.ProductLevel.selectLevelByModel(promodel).then(rd => {
          this.projectForm.designList[0].proLevelOne = rd.obj.oneName;
          this.projectForm.designList[0].proLevelTwo = rd.obj.twoName;
          this.projectForm.designList[0].proCode = rd.obj.proCode;
        });
      },
      //选择流标/废标
      changeResult(val){
        if(val == 3 || val == 4){
          this.projectForm.signDueTime = ''
        }
      },
      validateFieldPromise(fields) {
        return new Promise((resolve) => {
          if (!fields || fields.length === 0) {
            resolve({}); // 没有需要验证的字段直接 resolve
            return;
          }
          const allErrors = {}; // 收集所有字段的错误信息
          this.$refs.projectForm.validateField(fields, (error, field) => {
            // 记录当前字段的错误信息
            allErrors[field] = error;
            // 检查是否所有字段都已验证
            const isAllValidated = fields.every(field => allErrors.hasOwnProperty(field));
            if (isAllValidated) {
              resolve(allErrors); // 所有字段验证完成，返回错误信息集合
            }
          });
        });
      },
      //关闭
      closeStep(){
        this.closeProjectModal = true
        // this.$confirm('确定是否在此节点关闭当前项目?', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   //在这里做关闭
        //   ss.loud.closeStep(this.projectForm).then(rd => {
        //     this.subLoad = false
        //     if(rd.f == true){
        //       this.$message.success('已关闭')
        //     }
        //
        //   })
        // })
      },
      //完成
      submitStep(code,dateStr) {

        if(null != this.selectedValues && '' != this.selectedValues){
          this.projectForm.selectedValues = this.selectedValues.join(",");
        }
        if(this.projectForm.isBid == 0){
          this.$refs.projectForm.validate((valid) => {
            //是否招标---否
            if(valid){
              this.handleSubmit();
            }
          })
        }else{
          let fieldsToValidate = this.getFieldsToValidate(code)
          console.log(this.checkFieldStatus(this.projectForm,fieldsToValidate,dateStr))
          let isAll = this.checkFieldStatus(this.projectForm,fieldsToValidate,dateStr)
          console.log(isAll,'alll')
          //只要这个字段为true，那么就是当前节点只选了时间
          if(isAll.isScenarioA){
            console.log('可以只提交一个时间')
            //这里是只提交一个时间，清空页面其他剩余警告
            const otherFields = fieldsToValidate.filter(item => item != dateStr);
            this.$refs.projectForm.clearValidate(otherFields)
            this.handleSubmit();
          }else{
            console.log(fieldsToValidate,'xuyaoyanzheng de ')
            // 存储所有字段的验证结果
            const validationResults = {};
            // let allFieldsValidated = false;
            let totalFields = fieldsToValidate.length;
            let validatedFields = 0;
            // 验证所有字段
            fieldsToValidate.forEach(field => {
              this.$refs.projectForm.validateField(field, (error) => {
                validationResults[field] = !error; // 记录该字段是否验证通过
                validatedFields++;
                // 检查是否所有字段都已验证
                if (validatedFields == totalFields) {
                  // allFieldsValidated = true;
                  // 检查是否所有字段都通过验证
                  console.log(validationResults,'validationResults')
                  const isAllValid = Object.values(validationResults).every(result => result);
                  console.log(isAllValid,'isAllValid')
                  if (isAllValid) {
                    // 所有字段验证通过
                    console.log(` 验证通过`, this.projectForm);
                    // 这里添加实际的提交逻辑
                    this.handleSubmit();
                  } else {
                    // 存在未通过的字段
                    console.log(`验证失败`, validationResults);
                    // this.$message.error('请完善表单信息后再提交');
                  }
                }
              });
            });
          }
        }
        if(null != code){
          this.projectForm.statusR = code
        }
      },
      handleSubmit(){
        //如果是投标,不是X3或者X4
        if(this.projectForm.isBid == 1 && !this.selectedValues.includes("X3") && !this.selectedValues.includes("X4")){
          this.projectForm.products = [];
        }
        ss.loud.newSaveAndUpdateResource(this.projectForm).then(rd => {
          this.subLoad = false
          this.$msg.alert("提交成功！")
        })
      },
      // 辅助函数：判断一个值是否为"有值"（排除空字符串、null、undefined）
      hasValue (val){
        return val !== '' && val !== null && val !== undefined;
      },
      // 辅助函数：获取嵌套字段的值（如"designList[0].lianqun"）
      getFieldValue(form, fieldPath){
        return fieldPath.split('.').reduce((obj, key) => {
          // 处理数组格式（如"designList[0]"）
          const arrMatch = key.match(/^(\w+)\[(\d+)\]$/);
          if (arrMatch) {
            const [, arrKey, index] = arrMatch;
            return obj && obj[arrKey] ? obj[arrKey][index] : undefined;
          }
          return obj && obj[key] !== undefined ? obj[key] : undefined;
        }, form);
      },
      // 主判断函数
      checkFieldStatus(projectForm,fields,dateStr){
        console.log(projectForm,fields,dateStr)
        // const fields = ['dueDate', 'designList[0].lianqun', 'designList[0].proLevelOne', 'designList[0].proLevelTwo', 'designList[0].proModel', 'designList[0].proType'];
        // 分离dueDate和其他字段
        const dueDateField = dateStr;
        const otherFields = fields.filter(field => field !== dueDateField);
        console.log(dueDateField,otherFields,'otherFields')
        // 1. 检查dueDate是否有值
        const dueDateVal = this.getFieldValue(projectForm, dueDateField);
        if (!this.hasValue(dueDateVal)) {
          // dueDate无值，两种场景都不满足
          return { isScenarioA: false, isScenarioB: false };
        }

        // 2. 检查其他字段的有值/空值状态
        const otherFieldValues = otherFields.map(field => this.getFieldValue(projectForm, field));
        const hasValueCount = otherFieldValues.filter(val => this.hasValue(val)).length; // 其他字段中有值的数量
        const emptyCount = otherFields.length - hasValueCount; // 其他字段中空值的数量

        // 场景A：dueDate有值，其余字段全为空（hasValueCount === 0）
        const isScenarioA = hasValueCount === 0;

        // 场景B：dueDate有值，且其余字段"至少有一个有值"且"至少有一个为空"
        const isScenarioB = hasValueCount > 0 && emptyCount > 0;

        return { isScenarioA, isScenarioB };
      },

      contentdetails(row){
        this.contentdetailsAdd = true;
        this.loudId = this.id;
        this.loudCode = this.projectForm.funnelCode;
        this.loudStatusR = row;
        console.log( this.loudId, this.loudCode);
      },
      showUserList(value,index) {
        console.log('搜索关键词：', value, '当前行索引：', index);
        // 清空用户列表
        this.userList = [];

        // 空值判断：无搜索值时直接返回，避免无效请求
        if (!value) return;

        // 调用接口获取用户列表
        ss.MuBiao.selectUser(value).then(res => {
          console.log('接口返回数据：', res.obj);
          this.userList = res.obj || []; // 兼容接口返回null/undefined的情况
          // 替换为传统判空逻辑
          var currentSelect = this.$refs.usercodeRefs && this.$refs.usercodeRefs[index];
          if (!currentSelect) return;

          // 获取选中值的label并截取用户编码
          // 同样替换selected的可选链
          var selectedLabel = currentSelect.selected && currentSelect.selected.label;
          if (selectedLabel) {
            var valueCode = selectedLabel.split('-')[1];
            // 匹配用户编码并赋值
            res.obj.forEach(el => {
              if (el.usercode === valueCode) {
                this.formModel.loudContent[index].contentCode = el.usercode;
              }
            });
          }
        }).catch(err => {
          // 增加错误处理，避免接口报错导致页面异常
          console.error('获取用户列表失败：', err);
          this.$message.error('获取用户列表失败，请重试');
        });
      },
      // 处理用户选择变更
      handleUserChange(val, index) {
        if (val) {
          const [username, usercode] = val.split('-');
          this.formModel.loudContent[index].contentCode = usercode || '';
        } else {
          this.formModel.loudContent[index].contentCode = '';
        }
        this.formModel.loudContent[index].mainId = this.loudId;
        this.formModel.loudContent[index].funnelCode = this.loudCode;

        this.formModel.loudContent[index].loudStatusR = this.loudStatusR;

        console.log(this.formModel.loudContent)
      },

      addXtUser(){
        this.formModel.loudContent.push( {
          contentName:null,
          contentCode:null,
          funnelCode:null,
          loudStatusR:null,
          contentMsg:null,//协同信息
          reason:null,//拒绝协同原因
          userList:[],
        })
        //进行强制数据渲染
        this.$forceUpdate();
      },
      deleteXtUser(index){
        this.formModel.loudContent.splice(index, 1)
        //进行强制数据渲染
        this.$forceUpdate();
      },
      insertXt(){
        var data = this.formModel
        ss.loudnew.submitContent(data).then(res => {
          console.log(res)
          if (res.f == true) {
            this.$message({
              type: 'success',
              message: '提交成功!'
            });
            this.cancelXt()
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      cancelXt(){
        this.formModel.loudContent = [
          {
            mainId:null,
            contentName:null,
            contentCode:null,
            funnelCode:null,
            loudStatusR:null,
            contentMsg:null,//协同信息
            reason:null,//拒绝协同原因
            userList:[],
          }
        ];
        this.contentdetailsAdd = false;
      },

    },
    created() {
      this.getChainGroupList(); // 获取链群列表
      this.showChanceType(null);
      this.chanlList = this.$store.getters.dicts["sales_region"];
      this.loadAreas()
      this.id = this.$route.query.id;
      this.getById(this.id);
      this.selectOne();//查询一级分类
    }
  };
</script>

<style scoped lang="less">
  // 步骤条样式
  ::v-deep .el-steps {
    margin-bottom: 20px;

    .el-step {
      &.is-simple {
        .el-step__icon {
          display: none !important;
        }

        .el-step__title {
          //color: #606266;

          &.is-active {
            color: #1890ff;
            font-weight: bold;
          }
        }
      }

      &.custom-steps {
        pointer-events: auto !important;

        &.is-active::before,
        &.is-success::before {
          background-color: #e5e9f2 !important;
        }

        .el-step__icon {
          background-color: #fff !important;
          border-color: #e5e9f2 !important;
        }
      }
    }
  }

  ::v-deep .el-steps--simple {
    background: #F5F7FA;
    //padding: 10px 0;
  }

  // 表单样式
  ::v-deep .h-formbLine {
    .el-form-item {
      margin-bottom: 15px;

      &__label {
        width: 120px;
        color: #303133;
        font-weight: 500;
        padding-right: .16rem;
      }

      &__content {
        width: 60%;
      }
    }

    .h-elformWrap-2 {
      width: 32%;
      padding-right: 0;
    }
  }

  // 折叠面板样式
  .collapseTitle {
    font-size: 16px;
    //color: #0e75e9;
    font-weight: 700;
    line-height: 1.11;
    padding-left: 10px;
    border-left: 5px solid #0e75e9;
  }

  ::v-deep .el-collapse-item {
    //pointer-events: none;
    &__content {
      padding-bottom: 0;
      padding-top: 15px;
    }

    &:not(:last-child) {
      margin-bottom: 10px;
      border-bottom: 1px dashed #e4e7ed;
    }
  }

  ::v-deep .el-collapse-item__arrow{
    display: none;
  }

  // 产品项样式
  .product-item {
    padding: 15px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    margin-bottom: 15px;

    //&:last-child {
    //  margin-bottom: 0;
    //}
  }

  // 表单操作按钮样式
  .form-actions {
    margin-top: 30px;
    text-align: center;

    .el-button {
      margin: 0 10px;
      width: 120px;
    }
  }
  ::v-deep .h-formbLine .demandName .el-form-item__content {
    width: 83% !important;
  }
  // 步骤提交按钮样式
  .step-actions {
    margin: 20px 0;
    padding-top: 15px;
    //border-top: 1px dashed #e4e7ed;
    text-align: center;

    .el-button {
      margin-left: 10px;
    }
  }

  ::v-deep .el-checkbox__inner{
    border-radius: 50%;
    border: 1px solid #7e8281;
  }
  .form-header {
    text-align: right;
    //margin-bottom: 10px;
  }

  .form-item-wrap {
    position: relative;
    padding: 10px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    margin-bottom: 10px;
  }

  .delete-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 20px;
    color: crimson !important;
    margin-right: 0 !important;
  }
  .add-btn{
    font-size: 20px;
  }
  .form-item {
    margin-bottom: 10px;
  }
  .h-dialogForm{
    padding-top: 0;
  }
  ::v-deep .h-dialogForm .h-elformWrap-1 .el-form-item__content{
    width: 79% !important;
  }
  ::v-deep .h-dialog2 .el-dialog__footer{
    padding-bottom: 20px ;
  }
</style>
